
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2un4A", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");


var $c6GJD = parcelRequire("c6GJD");


var $6xdDU = parcelRequire("6xdDU");


var $dh538 = parcelRequire("dh538");


var $cwkWT = parcelRequire("cwkWT");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");


var $fDXXi = parcelRequire("fDXXi");


var $iBtX5 = parcelRequire("iBtX5");

var $kdU21 = parcelRequire("kdU21");


var $6fnsQ = parcelRequire("6fnsQ");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $d8SNb = parcelRequire("d8SNb");

var $eyWa4 = parcelRequire("eyWa4");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");



var $iXCQx = parcelRequire("iXCQx");


var $31Vvl = parcelRequire("31Vvl");

const $062849b5172bd26b$var$styles = {
    container: "_2rko12b0 _1h6d8yml _12y3e4h9 _12ji1l7x _1qu2nqa1 _syazi7uo _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    avatarSkeleton: "_2rko12b0 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    firstLineSkeleton: "_2rko1rr0 _1rjc1b66",
    secondLineSkeleton: "_2rko1rr0 _1rjc1b66 _1bsbqkoa"
};
const $062849b5172bd26b$export$b7a75d9378054329 = ({ containerType: containerType })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $062849b5172bd26b$var$styles.container,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.100",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    backgroundColor: "color.background.neutral",
                    xcss: $062849b5172bd26b$var$styles.avatarSkeleton
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.100",
                    grow: "fill",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            backgroundColor: "color.background.neutral",
                            xcss: $062849b5172bd26b$var$styles.firstLineSkeleton
                        }),
                        containerType ? /*#__PURE__*/ (0, $l998X.jsx)($062849b5172bd26b$var$ContainerIcon, {
                            containerType: containerType
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            backgroundColor: "color.background.neutral",
                            xcss: $062849b5172bd26b$var$styles.secondLineSkeleton
                        })
                    ]
                })
            ]
        })
    });
};
function $062849b5172bd26b$var$ContainerIcon({ containerType: containerType }) {
    const { description: description, icon: icon, containerTypeText: containerTypeText } = (0, $31Vvl.getContainerProperties)({
        containerType: containerType,
        iconSize: 'medium'
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        gap: "space.050",
        alignItems: "center",
        children: [
            icon,
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "small",
                        color: "color.text.subtle",
                        children: description
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "small",
                        color: "color.text.subtle",
                        children: containerTypeText
                    })
                ]
            })
        ]
    });
}


const $c6a66ab9fd93fec3$var$styles = {
    containers: "_yv0ewxkt",
    showMoreButtonSkeleton: "_2rko1tm3 _1rjc1b66 _1bsbvbgk"
};
const $c6a66ab9fd93fec3$export$b4d5d8f3bbe29b5f = ({ numberOfContainers: numberOfContainers })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.200",
        testId: "team-containers-skeleton",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $d8SNb.default), {
                xcss: $c6a66ab9fd93fec3$var$styles.containers,
                gap: "space.100",
                autoFlow: "row",
                children: [
                    ...Array(numberOfContainers)
                ].map((_, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $062849b5172bd26b$export$b7a75d9378054329), {}, index))
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                backgroundColor: "color.background.neutral",
                xcss: $c6a66ab9fd93fec3$var$styles.showMoreButtonSkeleton
            })
        ]
    });
};



var $hbp6S = parcelRequire("hbp6S");


var $cK1S8 = parcelRequire("cK1S8");


var $3ZPUI = parcelRequire("3ZPUI");


var $g1rvx = parcelRequire("g1rvx");








var $hogmh = parcelRequire("hogmh");

const $b07c34dd4d8ba0b7$var$PRODUCT_TO_CONTAINER_TYPE = {
    Jira: 'JiraProject',
    Confluence: 'ConfluenceSpace',
    Loom: 'LoomSpace'
};
const $b07c34dd4d8ba0b7$export$f2b2f5ef0b498d26 = 2000;
const $b07c34dd4d8ba0b7$export$128b56c8c806da23 = 30000;
const $b07c34dd4d8ba0b7$export$2a2e523635b9b98e = (teamId)=>{
    const [containers, { updateContainerLoading: updateContainerLoading, updateContainerCreated: updateContainerCreated }] = (0, $3ZPUI.useCreateContainers)();
    const { refetchTeamContainers: refetchTeamContainers, teamContainers: teamContainers } = (0, $hogmh.useTeamContainers)(teamId);
    const [createdContainers, setCreatedContainers] = (0, $42omo.useState)({});
    const intervalRef = (0, $42omo.useRef)(null);
    const clearIntervalRef = ()=>{
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };
    (0, $42omo.useEffect)(()=>{
        setCreatedContainers({});
        clearIntervalRef();
    }, [
        teamId
    ]);
    (0, $42omo.useEffect)(()=>{
        const products = Object.keys(containers);
        products.forEach((product)=>{
            const { isCreated: isCreated } = containers[product];
            if (!isCreated) return;
            const existing = createdContainers[product];
            if (existing && existing.found === false) return;
            if (existing && existing.found) return;
            const containerType = $b07c34dd4d8ba0b7$var$PRODUCT_TO_CONTAINER_TYPE[product];
            if (!containerType) return;
            const currentCount = teamContainers.filter((c)=>c.type === containerType).length;
            if (currentCount > 0) {
                setCreatedContainers((prev)=>({
                        ...prev,
                        [product]: {
                            startedAt: Date.now(),
                            found: true
                        }
                    }));
                updateContainerLoading(product, false);
                updateContainerCreated(product, false);
                return;
            }
            setCreatedContainers((prev)=>({
                    ...prev,
                    [product]: {
                        startedAt: Date.now(),
                        found: false
                    }
                }));
        });
    }, [
        containers,
        createdContainers,
        teamContainers,
        updateContainerLoading,
        updateContainerCreated
    ]);
    (0, $42omo.useEffect)(()=>{
        const hasPending = Object.values(createdContainers).some((entry)=>entry && entry.found === false);
        if (!hasPending) {
            clearIntervalRef();
            return;
        }
        if (intervalRef.current) return;
        intervalRef.current = setInterval(()=>{
            setCreatedContainers((prev)=>{
                let anyPending = false;
                const next = {
                    ...prev
                };
                Object.keys(prev).forEach((product)=>{
                    const target = prev[product];
                    if (!target || target.found) return;
                    const { startedAt: startedAt } = target;
                    const containerType = $b07c34dd4d8ba0b7$var$PRODUCT_TO_CONTAINER_TYPE[product];
                    if (!containerType) {
                        next[product] = {
                            ...target,
                            found: true
                        };
                        updateContainerLoading(product, false);
                        updateContainerCreated(product, false);
                        return;
                    }
                    const currentCount = teamContainers.filter((container)=>container.type === containerType).length;
                    const elapsed = Date.now() - startedAt;
                    if (currentCount > 0 || elapsed >= $b07c34dd4d8ba0b7$export$128b56c8c806da23) {
                        next[product] = {
                            ...target,
                            found: true
                        };
                        updateContainerLoading(product, false);
                        updateContainerCreated(product, false);
                    } else anyPending = true;
                });
                if (!anyPending) {
                    clearIntervalRef();
                    return next;
                }
                refetchTeamContainers();
                return next;
            });
        }, $b07c34dd4d8ba0b7$export$f2b2f5ef0b498d26);
        return ()=>{
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, [
        createdContainers,
        teamContainers,
        refetchTeamContainers,
        updateContainerLoading,
        updateContainerCreated
    ]);
};











var $8C5kA = parcelRequire("8C5kA");





var $8tdj3 = parcelRequire("8tdj3");





var $ftJwu = parcelRequire("ftJwu");

var $asH6r = parcelRequire("asH6r");













function $1df36a532911320d$var$useInterval(callback, delay) {
    const savedCallback = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $42omo.useEffect)(()=>{
        function tick() {
            if (savedCallback.current) savedCallback.current();
        }
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
        return;
    }, [
        delay
    ]);
}
var $1df36a532911320d$export$2e2bcd8739ae039 = $1df36a532911320d$var$useInterval;



var $exlO1 = parcelRequire("exlO1");

const $42a0f5834943b2fa$export$5e146b243177da33 = {
    [(0, $exlO1.ContainerType).CONFLUENCE_SPACE]: 'ConfluenceSpace',
    [(0, $exlO1.ContainerType).JIRA_PROJECT]: 'JiraProject',
    [(0, $exlO1.ContainerType).LOOM_SPACE]: 'LoomSpace'
};
const $42a0f5834943b2fa$var$CONTAINER_HUMAN_NAMES = {
    ConfluenceSpace: 'Confluence space',
    JiraProject: 'Jira project',
    LoomSpace: 'Loom space'
};
const $42a0f5834943b2fa$var$SEARCH_PARAM_NAME = 'requestedContainers';
function $42a0f5834943b2fa$export$2a1a0b9521e054c6(arr1, arr2) {
    return JSON.stringify([
        ...arr1
    ].sort()) === JSON.stringify([
        ...arr2
    ].sort());
}
function $42a0f5834943b2fa$export$6135988482c416bf() {
    const searchParams = new URLSearchParams(window.location.search);
    const values = searchParams.get($42a0f5834943b2fa$var$SEARCH_PARAM_NAME)?.split(',').filter(Boolean) || [];
    const containers = values.filter((value)=>Object.values((0, $exlO1.ContainerType)).includes(value)).map((value)=>$42a0f5834943b2fa$export$5e146b243177da33[value]);
    if (containers.length === 0) return [];
    return containers || [];
}
function $42a0f5834943b2fa$export$d3e8225e34bcdd7b() {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete($42a0f5834943b2fa$var$SEARCH_PARAM_NAME);
    window.history.replaceState({}, '', `${window.location.pathname}?${searchParams.toString()}`);
}
function $42a0f5834943b2fa$export$8882c1eb80c03e81(container) {
    return $42a0f5834943b2fa$var$CONTAINER_HUMAN_NAMES[container];
}
function $42a0f5834943b2fa$export$e4483a67fcde3e99(container) {
    switch(container){
        case 'ConfluenceSpace':
            return (0, $exlO1.ContainerType).CONFLUENCE_SPACE;
        case 'JiraProject':
            return (0, $exlO1.ContainerType).JIRA_PROJECT;
        case 'LoomSpace':
            return (0, $exlO1.ContainerType).LOOM_SPACE;
        default:
            return null;
    }
}
let $42a0f5834943b2fa$export$3af5babb39324657 = 1000;
let $42a0f5834943b2fa$export$a882ecf05d191257 = 15000;
/**
 * Hook for polling an async callback at a fixed interval, with timeout and pending state management.
 *
 * Starts polling the provided callback and stops after a set duration or when stopped manually.
 * Ensures only one callback is pending at a time.
 *
 * @param callback - The async function to poll.
 * @param onTimeout - Optional callback to execute when polling times out.
 * @returns An object with polling controls and state: startPolling, stopPolling, isPolling, hasTimedOut.
 */ function $42a0f5834943b2fa$export$5fb81aa4b17dfe23(callback, { onTimeout: onTimeout } = {}) {
    const [hasTimedOut, setHasTimedOut] = (0, $42omo.useState)(false);
    const timeoutRef = (0, $42omo.useRef)(null);
    const [isPolling, setIsPolling] = (0, $42omo.useState)(false);
    const [isPending, setIsPending] = (0, $42omo.useState)(false);
    const stopPolling = (0, $42omo.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setIsPolling(false);
        setHasTimedOut(false);
        setIsPending(false);
    }, []);
    const reset = (0, $42omo.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setHasTimedOut(false);
        setIsPolling(false);
        setIsPending(false);
    }, []);
    const startPolling = (0, $42omo.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setHasTimedOut(false);
        setIsPolling(true);
        setIsPending(false);
        timeoutRef.current = setTimeout(()=>{
            stopPolling();
            setHasTimedOut(true);
            if (onTimeout) onTimeout({
                startPolling: startPolling,
                stopPolling: stopPolling,
                reset: reset
            });
        }, $42a0f5834943b2fa$export$a882ecf05d191257);
    }, [
        stopPolling,
        onTimeout,
        reset
    ]);
    const wrappedCallback = (0, $42omo.useCallback)(async ()=>{
        if (isPending) return;
        setIsPending(true);
        try {
            await callback();
        } finally{
            setIsPending(false);
        }
    }, [
        callback,
        isPending
    ]);
    (0, $1df36a532911320d$export$2e2bcd8739ae039)(isPolling ? wrappedCallback : ()=>{}, isPolling ? $42a0f5834943b2fa$export$3af5babb39324657 : null);
    return {
        reset: reset,
        startPolling: startPolling,
        stopPolling: stopPolling,
        isPolling: isPolling,
        hasTimedOut: hasTimedOut
    };
}


/**
 * Hook to track and poll for requested product containers (such as a Jira Project).
 * The initial list of requested containers is derived from the URL parameters, however it can be updated based on user interactions.
 *
 * Manages a list of requested containers, polls for updates, and removes found containers from the list.
 *
 * Supported container types: CONFLUENCE_SPACE, JIRA_PROJECT, LOOM_SPACE.
 *
 * @param teamId - The ID of the team whose containers are being tracked.
 * @param onRequestedContainerTimeout - Optional callback to handle timeout events for requested containers.
 * @returns The current list of requested containers and a function to add a container.
 */ function $06335bbf15e8e2ca$export$e5b5663ca219614({ teamId: teamId, cloudId: cloudId, onRequestedContainerTimeout: onRequestedContainerTimeout }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { refetchTeamContainers: refetchTeamContainers, teamContainers: teamContainers } = (0, $hogmh.useTeamContainers)(teamId);
    const [isTryingAgain, setIsTryingAgain] = (0, $42omo.useState)(false);
    const tryAgainCountRef = (0, $42omo.useRef)(0);
    const [refetchErrorCount, setRefetchErrorCount] = (0, $42omo.useState)(0);
    const { fireTrackEvent: fireTrackEvent } = (0, $hbp6S.usePeopleAndTeamAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [requestedContainers, setRequestedContainers] = (0, $42omo.useState)([]);
    const requestedContainersRef = (0, $42omo.useRef)([]);
    const checkContainers = (0, $42omo.useCallback)(async ()=>{
        try {
            await refetchTeamContainers();
        } catch (error) {
            setRefetchErrorCount((prev)=>prev + 1);
        }
    }, [
        refetchTeamContainers
    ]);
    const onTimeout = (0, $42omo.useCallback)(({ startPolling: startPolling, reset: reset })=>{
        if (!onRequestedContainerTimeout) return;
        const reqContainers = requestedContainersRef.current;
        const flagId = `requested-container-timeout-${reqContainers.join('-')}-${tryAgainCountRef.current}`;
        const createTryAgainFlag = ({ onAction: onAction })=>({
                id: flagId,
                title: reqContainers.length === 1 ? formatMessage($06335bbf15e8e2ca$var$messages.timeoutTitle, {
                    container: (0, $42a0f5834943b2fa$export$8882c1eb80c03e81)(reqContainers[0])
                }) : formatMessage($06335bbf15e8e2ca$var$messages.timeoutTitleMultiple),
                description: formatMessage($06335bbf15e8e2ca$var$messages.timeoutDescription),
                appearance: 'error',
                type: 'error',
                actions: [
                    {
                        content: formatMessage($06335bbf15e8e2ca$var$messages.timeoutAction),
                        onClick: ()=>{
                            onAction(flagId);
                            tryAgainAction();
                        }
                    }
                ]
            });
        const createContactSupportFlag = ({ onAction: onAction })=>({
                id: flagId,
                title: formatMessage($06335bbf15e8e2ca$var$messages.noConnectionTitle),
                description: formatMessage($06335bbf15e8e2ca$var$messages.noConnectionDescription),
                appearance: 'error',
                type: 'error',
                actions: [
                    {
                        content: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            alignItems: "center",
                            columnGap: "space.100",
                            children: [
                                formatMessage($06335bbf15e8e2ca$var$messages.noConnectionAction),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                                    label: ""
                                })
                            ]
                        }),
                        onClick: ()=>{
                            onAction(flagId);
                        },
                        href: 'https://support.atlassian.com/contact/#/&support_type=customer'
                    }
                ]
            });
        const tryAgainAction = async ()=>{
            setIsTryingAgain(true);
            tryAgainCountRef.current = tryAgainCountRef.current + 1;
            const containers = reqContainers.map((container)=>{
                return {
                    type: (0, $42a0f5834943b2fa$export$e4483a67fcde3e99)(container),
                    containerSiteId: cloudId
                };
            }).filter(({ type: type })=>Boolean(type));
            fireTrackEvent(createAnalyticsEvent, {
                action: 'tryAgain',
                actionSubject: 'requestedContainers',
                // @ts-ignore
                attributes: {
                    containers: reqContainers,
                    teamId: teamId
                }
            });
            try {
                const response = await (0, $asH6r.teamsClient).createTeamContainers({
                    teamId: teamId,
                    containers: containers
                });
                const containersNotCreated = reqContainers.filter((containerType)=>!response.containersCreated?.some((container)=>container.containerType === (0, $42a0f5834943b2fa$export$e4483a67fcde3e99)(containerType)));
                //containers are still being created
                if (containersNotCreated.length > 0) startPolling();
                else {
                    //all containers created so reset and update state
                    reset();
                    await refetchTeamContainers();
                }
            } catch (error) {
                if (error instanceof (0, $ftJwu.HttpError)) {
                    if (error.status === 500) {
                        //only allow for 2 retries
                        if (tryAgainCountRef.current <= 2) return setTimeout(()=>{
                            //bug: this can cause two flags to be shown
                            tryAgainAction();
                        }, (0, $42a0f5834943b2fa$export$3af5babb39324657));
                    }
                }
                onRequestedContainerTimeout(createContactSupportFlag);
            } finally{
                setIsTryingAgain(false);
            }
        };
        fireTrackEvent(createAnalyticsEvent, {
            action: 'failed',
            actionSubject: 'requestedContainers',
            attributes: {
                // @ts-ignore
                containers: reqContainers,
                teamId: teamId,
                tryAgainCount: tryAgainCountRef.current
            }
        });
        (0, $42a0f5834943b2fa$export$d3e8225e34bcdd7b)();
        onRequestedContainerTimeout(tryAgainCountRef.current === 0 ? createTryAgainFlag : createContactSupportFlag);
    }, [
        cloudId,
        formatMessage,
        onRequestedContainerTimeout,
        refetchTeamContainers,
        teamId,
        createAnalyticsEvent,
        fireTrackEvent
    ]);
    const { startPolling: startPolling, stopPolling: stopPolling, isPolling: isPolling, hasTimedOut: hasTimedOut } = (0, $42a0f5834943b2fa$export$5fb81aa4b17dfe23)(checkContainers, {
        onTimeout: onTimeout
    });
    (0, $42omo.useEffect)(()=>{
        const containers = (0, $42a0f5834943b2fa$export$6135988482c416bf)();
        if (containers.length > 0 && isPolling === false) {
            setRequestedContainers(containers);
            startPolling();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        requestedContainersRef.current = requestedContainers;
    }, [
        requestedContainers
    ]);
    (0, $42omo.useEffect)(()=>{
        //stop gap to prevent sending too many failed errors
        if (refetchErrorCount > 3) {
            stopPolling();
            fireTrackEvent(createAnalyticsEvent, {
                action: 'failed',
                actionSubject: 'requestedContainers',
                attributes: {
                    // @ts-ignore
                    containers: requestedContainers,
                    teamId: teamId
                }
            });
            return;
        }
        if (hasTimedOut || isTryingAgain) return;
        const containerCount = requestedContainers.length;
        if (isPolling && containerCount === 0) {
            (0, $42a0f5834943b2fa$export$d3e8225e34bcdd7b)();
            stopPolling();
            return;
        }
    }, [
        isPolling,
        refetchErrorCount,
        requestedContainers,
        hasTimedOut,
        startPolling,
        stopPolling,
        isTryingAgain,
        teamId,
        createAnalyticsEvent,
        fireTrackEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        const containersNotFound = requestedContainers.filter((containerType)=>!teamContainers.some((teamContainer)=>teamContainer.type === containerType));
        if (!(0, $42a0f5834943b2fa$export$2a1a0b9521e054c6)(containersNotFound, requestedContainers)) setRequestedContainers(containersNotFound);
    }, [
        requestedContainers,
        checkContainers,
        teamContainers,
        isPolling
    ]);
    const containersLoading = (0, $42omo.useMemo)(()=>hasTimedOut && !isTryingAgain || refetchErrorCount > 3 ? [] : requestedContainers, [
        hasTimedOut,
        requestedContainers,
        isTryingAgain,
        refetchErrorCount
    ]);
    return {
        requestedContainers: containersLoading
    };
}
const $06335bbf15e8e2ca$var$messages = (0, $cgtv4.defineMessages)({
    timeoutTitle: {
        id: "teams-public.team-containers.timeout-title",
        defaultMessage: "We\u2019re couldn\u2019t connect your {container}"
    },
    timeoutTitleMultiple: {
        id: "teams-public.team-containers.timeout-title",
        defaultMessage: "We\u2019re couldn\u2019t connect your spaces"
    },
    timeoutDescription: {
        id: "teams-public.team-containers.timeout-description",
        defaultMessage: "Something went wrong. Verify your connection and retry."
    },
    timeoutAction: {
        id: "teams-public.team-containers.timeout-action",
        defaultMessage: "Try again"
    },
    noConnectionTitle: {
        id: "teams-public.team-containers.timeout-no-connection-title",
        defaultMessage: "Connection failed"
    },
    noConnectionDescription: {
        id: "teams-public.team-containers.timeout-no-connection-description",
        defaultMessage: "Try manually creating the space yourself."
    },
    noConnectionAction: {
        id: "teams-public.team-containers.timeout-no-connection-action",
        defaultMessage: "Contact support"
    }
});






var $aYWXT = parcelRequire("aYWXT");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $1qfLF = parcelRequire("1qfLF");


var $g5gZt = parcelRequire("g5gZt");






















parcelRequire("42omo");













function $2da7380ffeeec786$export$cd6d34d857ce4eca({ type: type }) {
    const { title: title, description: description } = $2da7380ffeeec786$var$getContainerProperties(type);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                maxLines: 1,
                weight: "medium",
                color: "color.text",
                children: title
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                gap: "space.050",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    size: "small",
                    color: "color.text.subtle",
                    children: description
                })
            })
        ]
    });
}
function $2da7380ffeeec786$var$getContainerProperties(type) {
    switch(type){
        case 'ConfluenceSpace':
            return {
                description: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$2da7380ffeeec786$var$messages.confluenceContainerDescription
                }),
                title: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$2da7380ffeeec786$var$messages.addConfluenceContainerTitle
                })
            };
        case 'LoomSpace':
            return {
                description: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$2da7380ffeeec786$var$messages.loomSpaceDescription
                }),
                title: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$2da7380ffeeec786$var$messages.addLoomContainerTitle
                })
            };
        case 'JiraProject':
            return {
                description: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$2da7380ffeeec786$var$messages.jiraProjectDescription
                }),
                title: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$2da7380ffeeec786$var$messages.addJiraProjectTitle
                })
            };
        case 'WebLink':
            return {
                description: null,
                title: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$2da7380ffeeec786$var$messages.addWebLinkTitle
                })
            };
        default:
            return {
                description: null,
                title: null
            };
    }
}
const $2da7380ffeeec786$var$messages = (0, $cgtv4.defineMessages)({
    addConfluenceContainerTitle: {
        id: "ptc-directory.team-profile-page.team-containers.create.add-confluence-space-title",
        defaultMessage: "Confluence space"
    },
    confluenceContainerDescription: {
        id: "ptc-directory.team-profile-page.team-containers.create.add-confluence-space-description",
        defaultMessage: "Create a knowledge bank"
    },
    addLoomContainerTitle: {
        id: "ptc-directory.team-profile-page.team-containers.create.add-loom-space-title",
        defaultMessage: "Loom space"
    },
    loomSpaceDescription: {
        id: "ptc-directory.team-profile-page.team-containers.create.add-loom-space-description",
        defaultMessage: "Share async updates"
    },
    addJiraProjectTitle: {
        id: "ptc-directory.team-profile-page.team-containers.create.add-jira-project-title",
        defaultMessage: "Jira project"
    },
    jiraProjectDescription: {
        id: "ptc-directory.team-profile-page.team-containers.create.add-jira-project-description",
        defaultMessage: "Plan out project tasks"
    },
    addWebLinkTitle: {
        id: "ptc-directory.team-profile-page.team-containers.create.add-web-link-title",
        defaultMessage: "Add any web link"
    }
});


const $9c9c7c8edc0a486e$var$styles = {
    card: "_4cvr1h6o _1bsb1osq",
    container: "_2rkoy0do _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _d0altlke",
    iconWrapper: "_2rko12b0 _12y3e4h9 _12ji1l7x _1qu2gq9o _syaz1rpy _4cvx1l7x _ksodnqa1"
};
const $9c9c7c8edc0a486e$var$AddContainerCardWrapper = ({ children: children, onClick: onClick })=>{
    const [hovered, setHovered] = (0, $42omo.useState)(false);
    const handleMouseEnter = ()=>setHovered(true);
    const handleMouseLeave = ()=>setHovered(false);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        backgroundColor: hovered ? 'elevation.surface.hovered' : 'elevation.surface.sunken',
        xcss: $9c9c7c8edc0a486e$var$styles.container,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: onClick,
        children: children
    });
};
const $9c9c7c8edc0a486e$export$7f436a9048e9eef4 = ({ containerType: containerType, onAddAContainerClick: onAddAContainerClick, isLoading: isLoading = false, showNewDesign: showNewDesign = false })=>{
    const { description: description, icon: icon, title: title } = (0, $31Vvl.getContainerProperties)({
        containerType: containerType,
        iconSize: (0, $dh538.fg)('enable_medium_size_icons_for_team_link_cards') ? 'medium' : undefined,
        isEmptyContainer: true
    });
    if (isLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $062849b5172bd26b$export$b7a75d9378054329), {
        containerType: containerType
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($9c9c7c8edc0a486e$var$AddContainerCardWrapper, {
        onClick: onAddAContainerClick,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.100",
            xcss: $9c9c7c8edc0a486e$var$styles.card,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $9c9c7c8edc0a486e$var$styles.iconWrapper,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        label: "Add a container",
                        appearance: "subtle",
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                                ...iconProps,
                                size: "small"
                            }),
                        testId: "add-icon",
                        onClick: (e)=>{
                            onAddAContainerClick(e);
                            e.stopPropagation();
                        }
                    })
                }),
                showNewDesign ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2da7380ffeeec786$export$cd6d34d857ce4eca), {
                    type: containerType
                }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    ...(0, $dh538.fg)('enable_medium_size_icons_for_team_link_cards') ? {
                        space: 'space.025'
                    } : {},
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            maxLines: 1,
                            weight: "medium",
                            color: "color.text",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            gap: "space.050",
                            alignItems: "center",
                            children: [
                                icon,
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    size: "small",
                                    color: "color.text.subtle",
                                    children: description
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $9c9c7c8edc0a486e$export$a1480278fb6646ef = ({ containers: containers, onAddAContainerClick: onAddAContainerClick, CustomAddContainerCard: CustomAddContainerCard, showNewDesign: showNewDesign })=>{
    const AddContainerCardComponent = CustomAddContainerCard ?? $9c9c7c8edc0a486e$export$7f436a9048e9eef4;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            containers.Jira.canAdd && /*#__PURE__*/ (0, $l998X.jsx)(AddContainerCardComponent, {
                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'Jira'),
                containerType: "JiraProject",
                isLoading: containers.Jira.isLoading,
                showNewDesign: showNewDesign
            }),
            containers.Confluence.canAdd && /*#__PURE__*/ (0, $l998X.jsx)(AddContainerCardComponent, {
                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'Confluence'),
                containerType: "ConfluenceSpace",
                isLoading: containers.Confluence.isLoading,
                showNewDesign: showNewDesign
            }),
            containers.Loom.canAdd && /*#__PURE__*/ (0, $l998X.jsx)(AddContainerCardComponent, {
                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'Loom'),
                containerType: "LoomSpace",
                isLoading: containers.Loom.isLoading,
                showNewDesign: showNewDesign
            }),
            containers.WebLink.canAdd && /*#__PURE__*/ (0, $l998X.jsx)(AddContainerCardComponent, {
                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'WebLink'),
                containerType: "WebLink",
                showNewDesign: showNewDesign
            })
        ]
    });
};





parcelRequire("42omo");


var $aqrhZ = parcelRequire("aqrhZ");


const $c26279cf8f73c062$var$DisconnectDialogLazyInner = (0, $aqrhZ.lazyForPaint)(()=>(parcelRequire("chP7f")).then(({ DisconnectDialog: DisconnectDialog })=>DisconnectDialog));
const $c26279cf8f73c062$export$3f4d3ee9eb71a228 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aqrhZ.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($c26279cf8f73c062$var$DisconnectDialogLazyInner, {
            ...props
        })
    });


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");







var $cO1el = parcelRequire("cO1el");








/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gj7hi = parcelRequire("gj7hi");




var $6cc5bf9e5f0c1b3b$exports = {};
$6cc5bf9e5f0c1b3b$exports = new URL("NoProductAccess.a65d0283.svg", import.meta.url).toString();


const $536c25e2a1eaecbd$var$styles = {
    icon: "_1ul9ys9h _p12fys9h"
};
function $536c25e2a1eaecbd$export$bf513868cd2f920f() {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $536c25e2a1eaecbd$var$styles.icon,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($6cc5bf9e5f0c1b3b$exports))),
            alt: ""
        })
    });
}


const $3dedcd9c7ca34a19$var$styles = {
    emptyStateContainer: "_2rko12b0 _189ee4h9 _1h6d1l7x _18zrpxbi _1rjcpxbi _12y3e4h9 _12ji1l7x _1qu2nqa1"
};
const $3dedcd9c7ca34a19$export$ecd1a08b364becd6 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        space: "space.100",
        xcss: $3dedcd9c7ca34a19$var$styles.emptyStateContainer,
        testId: "team-containers-no-product-access-state",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.200",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $536c25e2a1eaecbd$export$bf513868cd2f920f), {}),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        space: "space.200",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                size: "small",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...$3dedcd9c7ca34a19$var$messages.teamContainerEmptyStateTitle
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...$3dedcd9c7ca34a19$var$messages.teamContainerEmptyStateDescription
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $3dedcd9c7ca34a19$var$messages = (0, $cgtv4.defineMessages)({
    teamContainerEmptyStateTitle: {
        id: "ptc.team-profile-page.team-containers.empty-state.title",
        defaultMessage: "Add the places your team works"
    },
    teamContainerEmptyStateDescription: {
        id: "ptc.team-profile-page.team-containers.empty-state.description",
        defaultMessage: "Your team can link their Jira projects, Confluence spaces here to show where they work"
    }
});



var $6l0gG = parcelRequire("6l0gG");

const $4adb5a7a7d2f1b64$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $6fnsQ.N0)})`;
const $4adb5a7a7d2f1b64$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $6fnsQ.N90)})`;
const $4adb5a7a7d2f1b64$export$33f8090aba665a84 = 4;
const $4adb5a7a7d2f1b64$export$73c2d2b9b49926f5 = ({ teamId: teamId, onAddAContainerClick: onAddAContainerClick, onEditContainerClick: onEditContainerClick, onRequestedContainerTimeout: onRequestedContainerTimeout = ()=>{}, components: components, userId: userId, cloudId: cloudId, filterContainerId: filterContainerId, isDisplayedOnProfileCard: isDisplayedOnProfileCard, isReadOnly: isReadOnly, onError: onError, maxNumberOfContainersToShow: maxNumberOfContainersToShow = $4adb5a7a7d2f1b64$export$33f8090aba665a84, elemBeforeCards: elemBeforeCards, hideSubTextIcon: hideSubTextIcon })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { unlinkError: unlinkError } = (0, $hogmh.useTeamContainers)(teamId);
    const { teamLinks: teamLinks, removeTeamLink: removeTeamLink, iconsLoading: iconsLoading, iconHasLoaded: iconHasLoaded, hasError: hasError, isLoading: linksLoading } = (0, $aYWXT.useTeamLinksAndContainers)(teamId, true);
    const { requestedContainers: requestedContainers } = (0, $06335bbf15e8e2ca$export$e5b5663ca219614)({
        teamId: teamId,
        cloudId: cloudId,
        onRequestedContainerTimeout: onRequestedContainerTimeout
    });
    const [_, actions] = (0, $hogmh.useTeamContainersHook)();
    const [showMore, setShowMore] = (0, $42omo.useState)(false);
    const [isDisconnectDialogOpen, setIsDisconnectDialogOpen] = (0, $42omo.useState)(false);
    const [selectedContainerDetails, setSelectedContainerDetails] = (0, $42omo.useState)();
    const [filteredTeamLinks, setFilteredTeamLinks] = (0, $42omo.useState)(teamLinks);
    const [canAddContainer, setCanAddContainer] = (0, $42omo.useState)({
        Jira: false,
        Confluence: false,
        Loom: false,
        WebLink: false
    });
    const [containers] = (0, $3ZPUI.useCreateContainers)();
    const { fireTrackEvent: fireTrackEvent } = (0, $hbp6S.usePeopleAndTeamAnalytics)();
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const { data: productPermissions, loading: productPermissionIsLoading } = (0, $kdU21.useProductPermissions)({
        userId: userId,
        cloudId: cloudId,
        permissionsToCheck: {
            jira: [
                'CREATE_PROJECT',
                'manage',
                'write'
            ],
            loom: [
                'write',
                'manage'
            ],
            confluence: [
                'write',
                'manage',
                'CREATE_SPACE'
            ]
        },
        options: {
            enabled: (0, $dh538.fg)('migrate-product-permissions')
        }
    });
    const { data: productPermissionsOld, loading: productPermissionIsLoadingOld } = (0, $g1rvx.useProductPermissions)({
        userId: userId,
        cloudId: cloudId
    }, {
        enabled: !(0, $dh538.fg)('migrate-product-permissions')
    });
    (0, $b07c34dd4d8ba0b7$export$2a2e523635b9b98e)(teamId);
    const hasPermissionToCreateContainer = (0, $42omo.useMemo)(()=>{
        if (!productPermissions) return {};
        const getPermission = (product, permission)=>{
            return productPermissions && (0, $iBtX5.hasProductPermission)(productPermissions, product, permission);
        };
        return getPermission('confluence', [
            'CREATE_SPACE'
        ]) || getPermission('jira', [
            'CREATE_PROJECT'
        ]) || getPermission('loom', [
            'write'
        ]);
    }, [
        productPermissions
    ]);
    const createContainerExperimentEnabled = hasPermissionToCreateContainer && (0, $c6GJD.default).initializeCompleted() && (0, $c6GJD.default).getExperimentValue('teams_app_auto_container_creation', 'isEnabled', false);
    (0, $42omo.useEffect)(()=>{
        if (isDisplayedOnProfileCard && filterContainerId) setFilteredTeamLinks(teamLinks.filter((container)=>container.id !== filterContainerId));
        else setFilteredTeamLinks(teamLinks);
    }, [
        teamLinks,
        isDisplayedOnProfileCard,
        filterContainerId
    ]);
    (0, $42omo.useEffect)(()=>{
        const containersToCheck = filteredTeamLinks;
        if (containersToCheck.length > maxNumberOfContainersToShow || isDisplayedOnProfileCard || isReadOnly) setCanAddContainer({
            Jira: false,
            Confluence: false,
            Loom: false,
            WebLink: false
        });
        else {
            const containerExists = (type)=>containersToCheck.some((container)=>container.type === type);
            const showContainer = (containerExists, product)=>{
                if (containerExists) return false;
                if ((0, $dh538.fg)('migrate-product-permissions')) return productPermissions && (0, $iBtX5.hasProductPermission)(productPermissions, product, []) || false;
                return productPermissionsOld && (0, $cK1S8.hasProductPermission)(productPermissionsOld, product, []) || false;
            };
            setCanAddContainer({
                Jira: showContainer(containerExists('JiraProject'), 'jira'),
                Confluence: showContainer(containerExists('ConfluenceSpace'), 'confluence'),
                Loom: showContainer(containerExists('LoomSpace'), 'loom'),
                WebLink: !containerExists('WebLink')
            });
        }
    }, [
        isDisplayedOnProfileCard,
        productPermissions,
        productPermissionsOld,
        filteredTeamLinks,
        maxNumberOfContainersToShow,
        isReadOnly
    ]);
    (0, $42omo.useEffect)(()=>{
        if (onError) {
            if (hasError) onError(hasError);
            else if (unlinkError) onError(unlinkError);
        }
    }, [
        hasError,
        unlinkError,
        onError
    ]);
    const handleShowMore = ()=>{
        setShowMore(!showMore);
    };
    const handleOpenDisconnectDialog = (0, $42omo.useCallback)((containerDetails)=>{
        setSelectedContainerDetails(containerDetails);
        setIsDisconnectDialogOpen(true);
        if ((0, $dh538.fg)('ptc-enable-teams-public-analytics-refactor')) fireEvent('track.unlinkContainerDialog.opened', {
            teamId: teamId
        });
        else fireTrackEvent(createAnalyticsEvent, {
            action: (0, $hbp6S.AnalyticsAction).OPENED,
            actionSubject: 'unlinkContainerDialog',
            attributes: {
                teamId: teamId
            }
        });
    }, [
        createAnalyticsEvent,
        fireTrackEvent,
        teamId,
        fireEvent
    ]);
    const handleEditContainerClick = (0, $42omo.useCallback)((container)=>{
        if (container.type === 'WebLink' && onEditContainerClick) onEditContainerClick(container.id, container.link || '', container.name);
    }, [
        onEditContainerClick
    ]);
    const LinkedContainerCardComponent = components?.ContainerCard || (0, $6l0gG.TeamLinkCard);
    const handleDisconnect = (0, $42omo.useCallback)(async (containerId)=>{
        const removedContainer = filteredTeamLinks.find((container)=>container.id === containerId);
        if (removedContainer) await removeTeamLink(removedContainer);
        else await actions.unlinkTeamContainers(teamId, containerId);
        setIsDisconnectDialogOpen(false);
        if (unlinkError) {
            if ((0, $dh538.fg)('ptc-enable-teams-public-analytics-refactor')) fireEvent('track.teamContainerUnlinked.failed', {});
            else fireTrackEvent(createAnalyticsEvent, {
                action: (0, $hbp6S.AnalyticsAction).FAILED,
                actionSubject: 'teamContainerUnlinked'
            });
        } else if ((0, $dh538.fg)('ptc-enable-teams-public-analytics-refactor')) fireEvent('track.teamContainerUnlinked.succeeded', {
            containerRemoved: {
                containerId: removedContainer?.id,
                container: removedContainer?.type
            },
            teamId: teamId
        });
        else fireTrackEvent(createAnalyticsEvent, {
            action: (0, $hbp6S.AnalyticsAction).SUCCEEDED,
            actionSubject: 'teamContainerUnlinked',
            attributes: {
                containerRemoved: {
                    containerId: removedContainer?.id,
                    container: removedContainer?.type
                },
                teamId: teamId
            }
        });
    }, [
        actions,
        createAnalyticsEvent,
        fireTrackEvent,
        filteredTeamLinks,
        removeTeamLink,
        teamId,
        unlinkError,
        fireEvent
    ]);
    const TeamContainersSkeletonComponent = components?.TeamContainersSkeleton || (0, $c6a66ab9fd93fec3$export$b4d5d8f3bbe29b5f);
    const hasNoPermissions = (0, $42omo.useMemo)(()=>{
        if ((0, $dh538.fg)('migrate-product-permissions')) return productPermissions && !(0, $iBtX5.hasProductPermission)(productPermissions, 'jira') && !(0, $iBtX5.hasProductPermission)(productPermissions, 'confluence') && !(0, $iBtX5.hasProductPermission)(productPermissions, 'loom');
        return productPermissionsOld && !(0, $cK1S8.hasProductPermission)(productPermissionsOld, 'jira') && !(0, $cK1S8.hasProductPermission)(productPermissionsOld, 'confluence') && !(0, $cK1S8.hasProductPermission)(productPermissionsOld, 'loom');
    }, [
        productPermissions,
        productPermissionsOld
    ]);
    const hasNoContainers = (0, $42omo.useMemo)(()=>{
        return filteredTeamLinks.length === 0;
    }, [
        filteredTeamLinks
    ]);
    const isLoading = (0, $42omo.useMemo)(()=>{
        if (linksLoading) return true;
        if ((0, $dh538.fg)('migrate-product-permissions')) return productPermissionIsLoading;
        return productPermissionIsLoadingOld;
    }, [
        linksLoading,
        productPermissionIsLoading,
        productPermissionIsLoadingOld
    ]);
    const availableContainers = (0, $42omo.useMemo)(()=>{
        const getAvailableContainer = (productKey, requestedType)=>({
                canAdd: canAddContainer?.[productKey],
                isLoading: containers?.[productKey]?.isLoading || requestedContainers?.includes(requestedType)
            });
        return {
            Jira: getAvailableContainer('Jira', 'JiraProject'),
            Confluence: getAvailableContainer('Confluence', 'ConfluenceSpace'),
            Loom: getAvailableContainer('Loom', 'LoomSpace'),
            WebLink: getAvailableContainer('WebLink', 'WebLink')
        };
    }, [
        canAddContainer,
        containers,
        requestedContainers
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $l998X.jsx)(TeamContainersSkeletonComponent, {
        numberOfContainers: maxNumberOfContainersToShow
    });
    if (hasNoContainers) {
        if (components?.TeamContainersEmptyState) {
            const EmptyStateComponent = components.TeamContainersEmptyState;
            return /*#__PURE__*/ (0, $l998X.jsx)(EmptyStateComponent, {
                hasNoPermissions: !!hasNoPermissions
            });
        } else if (!isDisplayedOnProfileCard && hasNoPermissions) return /*#__PURE__*/ (0, $l998X.jsx)((0, $3dedcd9c7ca34a19$export$ecd1a08b364becd6), {});
    }
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                space: "space.200",
                children: [
                    (()=>{
                        const GridComponent = components?.Grid || (0, $cwkWT.default);
                        return /*#__PURE__*/ (0, $l998X.jsxs)(GridComponent, {
                            templateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                            gap: isDisplayedOnProfileCard ? 'space.0' : 'space.100',
                            children: [
                                elemBeforeCards && (()=>{
                                    const ElemBeforeCards = elemBeforeCards;
                                    return /*#__PURE__*/ (0, $l998X.jsx)(ElemBeforeCards, {});
                                })(),
                                filteredTeamLinks.slice(0, maxNumberOfContainersToShow).map((container)=>{
                                    return /*#__PURE__*/ (0, $l998X.jsx)(LinkedContainerCardComponent, {
                                        containerType: container.type,
                                        containerTypeProperties: container.containerTypeProperties,
                                        title: container.name,
                                        containerIcon: container.icon || undefined,
                                        link: container.link || undefined,
                                        containerId: container.id,
                                        iconsLoading: iconsLoading,
                                        iconHasLoaded: iconHasLoaded,
                                        isReadOnly: isReadOnly,
                                        hideSubTextIcon: hideSubTextIcon,
                                        onDisconnectButtonClick: ()=>handleOpenDisconnectDialog({
                                                containerId: container.id,
                                                containerType: container.type,
                                                containerName: container.name
                                            }),
                                        onEditLinkClick: ()=>handleEditContainerClick(container)
                                    }, container.id);
                                }),
                                (0, $9c9c7c8edc0a486e$export$a1480278fb6646ef)({
                                    containers: availableContainers,
                                    onAddAContainerClick: onAddAContainerClick,
                                    CustomAddContainerCard: components?.AddContainerCard,
                                    showNewDesign: createContainerExperimentEnabled
                                }),
                                showMore && filteredTeamLinks.slice(maxNumberOfContainersToShow).map((container)=>{
                                    return /*#__PURE__*/ (0, $l998X.jsx)(LinkedContainerCardComponent, {
                                        containerType: container.type,
                                        containerTypeProperties: container.containerTypeProperties,
                                        title: container.name,
                                        containerId: container.id,
                                        containerIcon: container.icon || undefined,
                                        link: container.link || undefined,
                                        iconsLoading: iconsLoading,
                                        iconHasLoaded: iconHasLoaded,
                                        isReadOnly: isReadOnly,
                                        hideSubTextIcon: hideSubTextIcon,
                                        onDisconnectButtonClick: ()=>handleOpenDisconnectDialog({
                                                containerId: container.id,
                                                containerType: container.type,
                                                containerName: container.name
                                            }),
                                        onEditLinkClick: ()=>handleEditContainerClick(container)
                                    }, container.id);
                                })
                            ]
                        });
                    })(),
                    filteredTeamLinks.length > maxNumberOfContainersToShow && /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            onClick: handleShowMore,
                            children: showMore ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...$4adb5a7a7d2f1b64$var$messages.showLess
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...$4adb5a7a7d2f1b64$var$messages.showMore
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
                children: isDisconnectDialogOpen && selectedContainerDetails && /*#__PURE__*/ (0, $l998X.jsx)((0, $c26279cf8f73c062$export$3f4d3ee9eb71a228), {
                    containerName: selectedContainerDetails.containerName,
                    containerType: selectedContainerDetails.containerType,
                    onClose: ()=>setIsDisconnectDialogOpen(false),
                    onDisconnect: ()=>handleDisconnect(selectedContainerDetails.containerId)
                })
            })
        ]
    });
};
const $4adb5a7a7d2f1b64$var$messages = (0, $cgtv4.defineMessages)({
    showMore: {
        id: "ptc-directory.team-profile-page.team-containers.show-more",
        defaultMessage: "Show more"
    },
    showLess: {
        id: "ptc-directory.team-profile-page.team-containers.show-less",
        defaultMessage: "Show less"
    }
});
module.exports["TeamContainers"] = $4adb5a7a7d2f1b64$export$73c2d2b9b49926f5;

});

parcelRegister("31Vvl", function(module, exports) {
/* get-container-properties.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $1Whri = parcelRequire("1Whri");


var $c6GJD = parcelRequire("c6GJD");


var $1bY7o = parcelRequire("1bY7o");


var $8tdj3 = parcelRequire("8tdj3");


var $gj7hi = parcelRequire("gj7hi");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $hWTBk = parcelRequire("hWTBk");


var $bjHDb = parcelRequire("bjHDb");

var $1bb75d114f5d6d80$exports = {};
$1bb75d114f5d6d80$exports = new URL("JiraProjectDiscovery.556db745.svg", import.meta.url).toString();


var $09ec6cdb17c1ce6a$exports = {};
$09ec6cdb17c1ce6a$exports = new URL("JiraServiceManagement.0b0134a3.svg", import.meta.url).toString();



var $dIk9b = parcelRequire("dIk9b");


var $eh61z = parcelRequire("eh61z");

const $c54f7acfc778f2e2$var$styles = {
    iconWrapper: "_1bsb1crf _4t3i1crf",
    avatarWrapper: "_1bsb1tcg _4t3i1tcg",
    avatarMargin: "_19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
    mediumIconWrapper: "_1bsb7vkz _4t3i7vkz",
    linkIconWrapper: "_2rkofajl _1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _12ji1l7x _1qu2nqa1",
    linkAvatarWrapper: "_2rko1eiz _1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o _bfhki8nm"
};
const $c54f7acfc778f2e2$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    addConfluenceContainerTitle: {
        id: "ptc-directory.team-profile-page.team-containers.add-confluence-space-title",
        defaultMessage: "Add space"
    },
    addConfluenceSpace: {
        id: "ptc-directory.team-profile-page.team-containers.add-confluence-space",
        defaultMessage: "Add Confluence Space"
    },
    confluenceContainerDescription: {
        id: "ptc-directory.team-profile-page.team-containers.add-confluence-space-description",
        defaultMessage: "Confluence"
    },
    addLoomContainerTitle: {
        id: "ptc-directory.team-profile-page.team-containers.add-loom-space-title",
        defaultMessage: "Add space"
    },
    addLoomSpace: {
        id: "ptc-directory.team-profile-page.team-containers.add-loom-space",
        defaultMessage: "Add Loom Space"
    },
    confluenceLoomDescription: {
        id: "ptc-directory.team-profile-page.team-containers.add-loom-space-description",
        defaultMessage: "Loom"
    },
    addJiraProjectTitle: {
        id: "ptc-directory.team-profile-page.team-containers.add-jira-project-title",
        defaultMessage: "Add project"
    },
    addJiraProject: {
        id: "ptc-directory.team-profile-page.team-containers.add-jira-project",
        defaultMessage: "Add Jira Project"
    },
    jiraProjectDescription: {
        id: "ptc-directory.team-profile-page.team-containers.add-jira-project-description",
        defaultMessage: "Jira"
    },
    addLoomSpaceTitle: {
        id: "ptc-directory.team-profile-page.team-containers.add-loom-space-title",
        defaultMessage: "Add space"
    },
    loomSpaceDescription: {
        id: "ptc-directory.team-profile-page.team-containers.add-loom-space-description",
        defaultMessage: "Loom"
    },
    projectContainerText: {
        id: "ptc-directory.team-profile-page.team-containers.project-container-text",
        defaultMessage: "project"
    },
    spaceContainerText: {
        id: "ptc-directory.team-profile-page.team-containers.space-container-text",
        defaultMessage: "space"
    },
    spaceContainerTextOverride: {
        id: "ptc-directory.team-profile-page.team-containers.space-container-text-override",
        defaultMessage: "Space"
    },
    emptyLinkContainerDescription: {
        id: "platform.teams.containers.empty-link-description",
        defaultMessage: "Add any link"
    },
    addLink: {
        id: "platform.teams.containers.add-link",
        defaultMessage: "Add Link"
    },
    linkContainerDescription: {
        id: "platform.teams.containers.link-title-description",
        defaultMessage: "Link"
    }
});
const $c54f7acfc778f2e2$var$getJiraIcon = (containerSubTypes)=>{
    switch(containerSubTypes){
        case 'PRODUCT_DISCOVERY':
            return 0, (/*@__PURE__*/$parcel$interopDefault($1bb75d114f5d6d80$exports));
        case 'SERVICE_DESK':
            return 0, (/*@__PURE__*/$parcel$interopDefault($09ec6cdb17c1ce6a$exports));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($bjHDb));
    }
};
const $c54f7acfc778f2e2$var$getJiraContainerProperties = ({ containerTypeProperties: containerTypeProperties, iconSize: iconSize = 'small' })=>{
    const newTeamProfilePage = (0, $c6GJD.default).getExperimentValue('new_team_profile', 'isEnabled', false);
    const isTeamLensInHomeEnabled = (0, $eh61z.getIsExperimentEnabled)('team_lens_in_atlassian_home');
    const { subType: subType, name: name } = containerTypeProperties || {};
    const baseProperties = {
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$c54f7acfc778f2e2$export$defe85febe8b728c.jiraProjectDescription
        }),
        icon: newTeamProfilePage ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
            xcss: (0, $1Whri.cx)($c54f7acfc778f2e2$var$styles.avatarWrapper, $c54f7acfc778f2e2$var$styles.avatarMargin),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                src: $c54f7acfc778f2e2$var$getJiraIcon(subType),
                alt: "",
                testId: "jira-project-container-icon"
            })
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
            xcss: iconSize === 'medium' ? $c54f7acfc778f2e2$var$styles.mediumIconWrapper : $c54f7acfc778f2e2$var$styles.iconWrapper,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                src: $c54f7acfc778f2e2$var$getJiraIcon(subType),
                alt: "",
                testId: "jira-project-container-icon"
            })
        }),
        title: newTeamProfilePage ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$c54f7acfc778f2e2$export$defe85febe8b728c.addJiraProject
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$c54f7acfc778f2e2$export$defe85febe8b728c.addJiraProjectTitle
        }),
        containerTypeText: newTeamProfilePage || isTeamLensInHomeEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$c54f7acfc778f2e2$export$defe85febe8b728c.spaceContainerTextOverride
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$c54f7acfc778f2e2$export$defe85febe8b728c.projectContainerText
        })
    };
    switch(subType){
        case 'PRODUCT_DISCOVERY':
        case 'SERVICE_DESK':
            return {
                ...baseProperties,
                containerTypeText: '',
                description: name || baseProperties.description
            };
        default:
            return baseProperties;
    }
};
const $c54f7acfc778f2e2$var$getWebLinkContainerProperties = ({ isEmptyContainer: isEmptyContainer, isDisplayedOnProfileCard: isDisplayedOnProfileCard })=>{
    const newTeamProfilePage = (0, $c6GJD.default).getExperimentValue('new_team_profile', 'isEnabled', false);
    return {
        description: isEmptyContainer ? /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            size: "medium",
            weight: "medium",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...$c54f7acfc778f2e2$export$defe85febe8b728c.emptyLinkContainerDescription
            })
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$c54f7acfc778f2e2$export$defe85febe8b728c.linkContainerDescription
        }),
        icon: isEmptyContainer ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($c54f7acfc778f2e2$var$styles.linkAvatarWrapper, newTeamProfilePage && $c54f7acfc778f2e2$var$styles.avatarMargin),
            testId: "team-link-card-globe-icon",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                label: "",
                size: "medium"
            })
        }) : isDisplayedOnProfileCard ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
            label: "",
            size: "small",
            testId: "team-link-card-external-link-icon"
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $c54f7acfc778f2e2$var$styles.linkIconWrapper,
            testId: "team-link-card-globe-icon",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                label: "",
                size: "small"
            })
        }),
        title: newTeamProfilePage ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$c54f7acfc778f2e2$export$defe85febe8b728c.addLink
        }) : null,
        containerTypeText: null
    };
};
const $c54f7acfc778f2e2$export$4fa7913af1c65224 = ({ containerType: containerType, iconSize: iconSize = 'small', containerTypeProperties: containerTypeProperties, isEmptyContainer: isEmptyContainer, isDisplayedOnProfileCard: isDisplayedOnProfileCard })=>{
    const newTeamProfilePage = (0, $c6GJD.default).getExperimentValue('new_team_profile', 'isEnabled', false);
    const isTeamLensInHomeEnabled = (0, $eh61z.getIsExperimentEnabled)('team_lens_in_atlassian_home');
    switch(containerType){
        case 'ConfluenceSpace':
            return {
                description: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.confluenceContainerDescription
                }),
                icon: newTeamProfilePage ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                    xcss: (0, $1Whri.cx)($c54f7acfc778f2e2$var$styles.avatarWrapper, $c54f7acfc778f2e2$var$styles.avatarMargin),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($hWTBk))),
                        alt: "",
                        testId: "confluence-space-container-icon"
                    })
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                    xcss: iconSize === 'medium' ? $c54f7acfc778f2e2$var$styles.mediumIconWrapper : $c54f7acfc778f2e2$var$styles.iconWrapper,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($hWTBk))),
                        alt: "",
                        testId: "confluence-space-container-icon"
                    })
                }),
                title: newTeamProfilePage ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.addConfluenceSpace
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.addConfluenceContainerTitle
                }),
                containerTypeText: newTeamProfilePage || isTeamLensInHomeEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.spaceContainerTextOverride
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.spaceContainerText
                })
            };
        case 'LoomSpace':
            return {
                description: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.loomSpaceDescription
                }),
                icon: newTeamProfilePage ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                    xcss: (0, $1Whri.cx)($c54f7acfc778f2e2$var$styles.avatarWrapper, $c54f7acfc778f2e2$var$styles.avatarMargin),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($dIk9b))),
                        alt: "",
                        testId: "loom-space-container-icon"
                    })
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                    xcss: iconSize === 'medium' ? $c54f7acfc778f2e2$var$styles.mediumIconWrapper : $c54f7acfc778f2e2$var$styles.iconWrapper,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($dIk9b))),
                        alt: "",
                        testId: "loom-space-container-icon"
                    })
                }),
                title: newTeamProfilePage ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.addLoomSpace
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.addLoomContainerTitle
                }),
                containerTypeText: newTeamProfilePage || isTeamLensInHomeEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.spaceContainerTextOverride
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.spaceContainerText
                })
            };
        case 'JiraProject':
            return $c54f7acfc778f2e2$var$getJiraContainerProperties({
                containerTypeProperties: containerTypeProperties,
                iconSize: iconSize
            });
        case 'WebLink':
            return $c54f7acfc778f2e2$var$getWebLinkContainerProperties({
                isEmptyContainer: isEmptyContainer,
                isDisplayedOnProfileCard: isDisplayedOnProfileCard
            });
        default:
            return {
                description: null,
                icon: null,
                title: null,
                containerTypeText: null
            };
    }
};
module.exports["getContainerProperties"] = $c54f7acfc778f2e2$export$4fa7913af1c65224;

});

parcelRegister("hWTBk", function(module, exports) {
module.exports = new URL("ConfluenceIcon.3b027e05.svg", import.meta.url).toString();

});

parcelRegister("bjHDb", function(module, exports) {
module.exports = new URL("JiraIcon.a06d5f95.svg", import.meta.url).toString();

});

parcelRegister("dIk9b", function(module, exports) {
module.exports = new URL("LoomIcon.8c0f7a38.svg", import.meta.url).toString();

});

parcelRegister("eh61z", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");

const $a6e42e725e6cb606$export$8cdfc3fcb89be49c = 'cohort';
const $a6e42e725e6cb606$export$5b7423264d48ab04 = 'not-enrolled';
const $a6e42e725e6cb606$export$43f367b3e957f219 = 'control';
const $a6e42e725e6cb606$export$9ba2bc3b1bdc1519 = 'experiment';
const $a6e42e725e6cb606$export$fa04ad826acc90da = 'variation';
const $a6e42e725e6cb606$export$6486974e39493fa6 = 'variation_1';
const $a6e42e725e6cb606$export$7d994996134ad562 = 'variation_2';
const $a6e42e725e6cb606$export$795e7d69b248dcd0 = 'variation_3';
const $a6e42e725e6cb606$export$c9c947c57470b787 = 'variation_4';
const $a6e42e725e6cb606$export$41e53468fd9b415a = {
    NOT_ENROLLED: $a6e42e725e6cb606$export$5b7423264d48ab04,
    CONTROL: $a6e42e725e6cb606$export$43f367b3e957f219,
    EXPERIMENT: $a6e42e725e6cb606$export$9ba2bc3b1bdc1519,
    VARIATION: $a6e42e725e6cb606$export$fa04ad826acc90da,
    VAR1: $a6e42e725e6cb606$export$6486974e39493fa6,
    VAR2: $a6e42e725e6cb606$export$7d994996134ad562,
    VAR3: $a6e42e725e6cb606$export$795e7d69b248dcd0,
    VAR4: $a6e42e725e6cb606$export$c9c947c57470b787
};
const $a6e42e725e6cb606$export$3b280d020d346fbd = Object.values($a6e42e725e6cb606$export$41e53468fd9b415a);
const $a6e42e725e6cb606$export$6de38be06f745dec = (experimentName, variantKey = $a6e42e725e6cb606$export$fa04ad826acc90da, validExperimentCohorts = $a6e42e725e6cb606$export$3b280d020d346fbd, fireExperimentExposure = true)=>{
    if ((0, $c6GJD.default).initializeCalled()) {
        const cohort = (0, $c6GJD.default).getExperimentValue(experimentName, $a6e42e725e6cb606$export$8cdfc3fcb89be49c, $a6e42e725e6cb606$export$5b7423264d48ab04, {
            fireExperimentExposure: fireExperimentExposure
        });
        const isValid = typeof cohort === 'string' && validExperimentCohorts.includes(cohort);
        return (isValid ? cohort : $a6e42e725e6cb606$export$5b7423264d48ab04) === variantKey;
    }
    return false;
};
module.exports["getIsExperimentEnabled"] = $a6e42e725e6cb606$export$6de38be06f745dec;

});

parcelRegister("hbp6S", function(module, exports) {

var $iKx9t = parcelRequire("iKx9t");

const $f89d3a6c9232b957$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $f89d3a6c9232b957$var$runItLater = (cb)=>{
    if (window.requestIdleCallback === 'function') return window.requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $f89d3a6c9232b957$export$c673a0f984c6d01b = ()=>{
    const [{ eventAttributes: injectedEventAttributes }] = (0, $iKx9t.usePeopleTeamsAnalyticsSubcontext)();
    const fireEvent = (kind)=>(createAnalyticsEvent, body)=>{
            if (!createAnalyticsEvent) return;
            $f89d3a6c9232b957$var$runItLater(()=>{
                const eventWithSubcontextAttributes = {
                    ...body.attributes,
                    ...injectedEventAttributes
                };
                createAnalyticsEvent({
                    eventType: kind,
                    ...body,
                    attributes: eventWithSubcontextAttributes
                }).fire($f89d3a6c9232b957$var$ANALYTICS_CHANNEL);
            });
        };
    return {
        fireOperationalEvent: fireEvent('operational'),
        fireScreenEvent: fireEvent('screen'),
        fireTrackEvent: fireEvent('track'),
        fireUIEvent: fireEvent('ui')
    };
};
var $f89d3a6c9232b957$export$30c16f5c43437fd7 = /*#__PURE__*/ function(AnalyticsAction) {
    AnalyticsAction["RENDERED"] = "rendered";
    AnalyticsAction["CLICKED"] = "clicked";
    AnalyticsAction["FAILED"] = "failed";
    AnalyticsAction["SUCCEEDED"] = "succeeded";
    AnalyticsAction["VIEWED"] = "viewed";
    AnalyticsAction["CLOSED"] = "closed";
    AnalyticsAction["ERROR"] = "error";
    AnalyticsAction["SUBMITED"] = "submitted";
    AnalyticsAction["FETCHED"] = "fetched";
    AnalyticsAction["SENT"] = "sent";
    AnalyticsAction["OPENED"] = "opened";
    return AnalyticsAction;
}({});
module.exports["usePeopleAndTeamAnalytics"] = $f89d3a6c9232b957$export$c673a0f984c6d01b;
module.exports["AnalyticsAction"] = $f89d3a6c9232b957$export$30c16f5c43437fd7;

});

parcelRegister("iKx9t", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $5aed317b00f8e39a$var$initialState = {
    eventAttributes: {}
};
const $5aed317b00f8e39a$var$actions = {
    setEventAttributes: (eventAttributes)=>({ setState: setState, getState: getState })=>{
            const existingEventAttributes = getState().eventAttributes;
            const newEventAttributes = {
                ...existingEventAttributes,
                ...eventAttributes
            };
            Object.keys(newEventAttributes).forEach((keyString)=>{
                const key = keyString;
                if (newEventAttributes[key] === undefined) delete newEventAttributes[key];
            });
            setState({
                eventAttributes: newEventAttributes
            });
        }
};
const $5aed317b00f8e39a$var$AnalyticsSubcontextStore = (0, $1P1Tu.createStore)({
    initialState: $5aed317b00f8e39a$var$initialState,
    actions: $5aed317b00f8e39a$var$actions
});
const $5aed317b00f8e39a$export$86448e866930ba8d = (0, $9zUhf.createHook)($5aed317b00f8e39a$var$AnalyticsSubcontextStore);
const $5aed317b00f8e39a$export$831917a198e22e70 = (key, value)=>{
    const { setEventAttributes: setEventAttributes } = $5aed317b00f8e39a$export$86448e866930ba8d()[1];
    (0, $42omo.useEffect)(()=>{
        setEventAttributes({
            [key]: value
        });
        return ()=>setEventAttributes({
                [key]: undefined
            });
    }, [
        key,
        value,
        setEventAttributes
    ]);
};
module.exports["usePeopleTeamsAnalyticsSubcontext"] = $5aed317b00f8e39a$export$86448e866930ba8d;

});

parcelRegister("cK1S8", function(module, exports) {
const $dfa26afbcfbb5a27$export$69caceff42c0da80 = [
    'confluence',
    'jira',
    'loom'
];


const $0e8298b04935fd86$var$PRODUCTS = [
    'confluence',
    'jira',
    'jira-core',
    'jira-software',
    'jira-servicedesk',
    'jira-product-discovery',
    'loom'
];
const $0e8298b04935fd86$export$7fe0bfa353103198 = (permissions)=>{
    return permissions.reduce((acc, permission)=>{
        (0, $dfa26afbcfbb5a27$export$69caceff42c0da80).forEach((supportedProduct)=>{
            if (permission.resourceId.includes(supportedProduct)) acc[supportedProduct] = {
                ...acc[supportedProduct],
                [permission.permissionId]: acc[supportedProduct]?.[permission.permissionId] || permission.permitted
            };
        });
        return acc;
    }, {});
};
const $0e8298b04935fd86$export$e16fe80afd1ad74c = (cloudId, userId, permissionIds)=>{
    const body = permissionIds.reduce((acc, permissionId)=>{
        const permission = {
            permissionId: permissionId,
            resourceId: '',
            principalId: `ari:cloud:identity::user/${userId}`,
            dontRequirePrincipalInSite: true
        };
        $0e8298b04935fd86$var$PRODUCTS.forEach((product)=>{
            acc.push({
                ...permission,
                resourceId: `ari:cloud:${product}::site/${cloudId}`
            });
        });
        return acc;
    }, []);
    return JSON.stringify(body);
};
const $0e8298b04935fd86$export$a2eea90ce05a9f1c = (permissions, product, permissionIds)=>{
    if (!permissions[product]) return false;
    if ((!permissionIds || permissionIds.length === 0) && permissions[product]) return Object.values(permissions[product] || {}).some((value)=>value === true);
    return permissionIds?.some((permissionId)=>{
        const productPermissions = permissions[product];
        return productPermissions?.[permissionId];
    });
};
module.exports["transformPermissions"] = $0e8298b04935fd86$export$7fe0bfa353103198;
module.exports["getProductPermissionRequestBody"] = $0e8298b04935fd86$export$e16fe80afd1ad74c;
module.exports["hasProductPermission"] = $0e8298b04935fd86$export$a2eea90ce05a9f1c;

});

parcelRegister("3ZPUI", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $61fa4b3495654927$var$actions = {
    updateContainerLoading: (product, isLoading)=>({ setState: setState, getState: getState })=>{
            const containers = getState();
            const current = containers[product];
            if (current.isLoading === isLoading) return;
            setState({
                ...containers,
                [product]: {
                    ...current,
                    isLoading: isLoading
                }
            });
        },
    updateContainerCreated: (product, isCreated)=>({ setState: setState, getState: getState })=>{
            const containers = getState();
            const current = containers[product];
            if (current.isCreated === isCreated) return;
            setState({
                ...containers,
                [product]: {
                    ...current,
                    isCreated: isCreated
                }
            });
        }
};
const $61fa4b3495654927$var$initialState = {
    Jira: {
        isLoading: false,
        isCreated: false
    },
    Confluence: {
        isLoading: false,
        isCreated: false
    },
    Loom: {
        isLoading: false,
        isCreated: false
    }
};
const $61fa4b3495654927$var$store = (0, $1P1Tu.createStore)({
    initialState: $61fa4b3495654927$var$initialState,
    actions: $61fa4b3495654927$var$actions,
    name: 'CreateContainers'
});
/**
 * Custom hook for accessing and updating the state of container creation (Jira, Confluence, Loom).
 *
 * Provides state and actions for loading and creation status of each container type.
 *
 * @returns {object} State and actions for managing container creation.
 */ const $61fa4b3495654927$export$4775ec854211567 = (0, $9zUhf.createHook)($61fa4b3495654927$var$store);
module.exports["useCreateContainers"] = $61fa4b3495654927$export$4775ec854211567;

});

parcelRegister("g1rvx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $cK1S8 = parcelRequire("cK1S8");

const $3124300e7fe6b906$var$actions = {
    getPermissions: ({ userId: userId, cloudId: cloudId, enabled: enabled, permissionIds: permissionIds = [
        'manage',
        'write'
    ] })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { hasLoaded: hasLoaded, isLoading: isLoading, permissions: permissions } = getState();
            if (isLoading || !userId || !cloudId || !enabled) return;
            const shouldFetch = !hasLoaded || permissionIds.some((permissionId)=>permissions.confluence?.[permissionId] === undefined || permissions.jira?.[permissionId] === undefined || permissions.loom?.[permissionId] === undefined);
            if (!shouldFetch) return;
            try {
                setState({
                    isLoading: true
                });
                const response = await fetch('/gateway/api/permissions/bulk/permitted', {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    method: 'POST',
                    credentials: 'include',
                    body: (0, $cK1S8.getProductPermissionRequestBody)(cloudId, userId, permissionIds)
                });
                if (!response.ok) throw new Error('Failed to fetch product permissions');
                const permissions = await response.json();
                dispatch($3124300e7fe6b906$var$actions.setPermissions(permissions));
            } catch (error) {
                dispatch($3124300e7fe6b906$var$actions.setError(new Error('Failed to fetch product permissions')));
            }
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                error: error
            });
        },
    setLoading: (isLoading)=>({ setState: setState })=>{
            setState({
                isLoading: isLoading
            });
        },
    setPermissions: (permissions)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                permissions: (0, $cK1S8.transformPermissions)(permissions),
                permissionsResponse: permissions
            });
        }
};
const $3124300e7fe6b906$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        error: undefined,
        hasLoaded: false,
        isLoading: false,
        permissions: {}
    },
    actions: $3124300e7fe6b906$var$actions,
    name: 'product-permissions-old'
});
const $3124300e7fe6b906$export$933ed92af1ed5de9 = (0, $9zUhf.createHook)($3124300e7fe6b906$var$Store);


const $c62cb3f798a3455e$export$5814f9544ee53f3b = ({ userId: userId, cloudId: cloudId, permissionIds: permissionIds }, { enabled: enabled } = {
    enabled: true
})=>{
    const [state, { getPermissions: getPermissions }] = (0, $3124300e7fe6b906$export$933ed92af1ed5de9)();
    const fetchData = (0, $42omo.useCallback)(async ()=>{
        getPermissions({
            cloudId: cloudId,
            userId: userId,
            enabled: enabled,
            permissionIds: permissionIds || [
                'manage',
                'write'
            ]
        });
    }, [
        cloudId,
        enabled,
        getPermissions,
        userId,
        permissionIds
    ]);
    (0, $42omo.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    return {
        loading: state.isLoading,
        data: state.permissions,
        error: state.error
    };
};
module.exports["useProductPermissions"] = $c62cb3f798a3455e$export$5814f9544ee53f3b;

});

parcelRegister("hogmh", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $fDXXi = parcelRequire("fDXXi");


var $asH6r = parcelRequire("asH6r");


var $hbp6S = parcelRequire("hbp6S");

const $f181d773681f14f5$var$initialConnectedTeamsState = {
    containerId: undefined,
    isLoading: false,
    hasLoaded: false,
    teams: undefined,
    error: null,
    numberOfTeams: undefined
};
const $f181d773681f14f5$var$initialState = {
    teamContainers: [],
    loading: true,
    hasLoaded: false,
    error: null,
    unlinkError: null,
    teamId: null,
    connectedTeams: $f181d773681f14f5$var$initialConnectedTeamsState
};
function $f181d773681f14f5$var$containersEqual(arr1, arr2) {
    const sortById = (a, b)=>a.id.localeCompare(b.id);
    return JSON.stringify([
        ...arr1
    ].sort(sortById)) === JSON.stringify([
        ...arr2
    ].sort(sortById));
}
const $f181d773681f14f5$var$actions = {
    fetchTeamContainers: (teamId, fireAnalytics, fireAnalyticsNext)=>async ({ setState: setState, getState: getState })=>{
            const { teamId: currentTeamId } = getState();
            if (currentTeamId === teamId) return;
            setState({
                loading: true,
                error: null,
                teamContainers: [],
                teamId: teamId,
                hasLoaded: false
            });
            try {
                const containers = await (0, $asH6r.teamsClient).getTeamContainers(teamId);
                if ((0, $dh538.fg)('ptc-enable-teams-public-analytics-refactor')) fireAnalyticsNext('operational.fetchTeamContainers.succeeded', {
                    teamId: teamId
                });
                else fireAnalytics((0, $hbp6S.AnalyticsAction).SUCCEEDED, 'fetchTeamContainers');
                setState({
                    teamContainers: containers,
                    loading: false,
                    error: null,
                    hasLoaded: true
                });
            } catch (err) {
                if ((0, $dh538.fg)('ptc-enable-teams-public-analytics-refactor')) fireAnalyticsNext('operational.fetchTeamContainers.failed', {
                    teamId: teamId,
                    error: {
                        message: err.message || JSON.stringify(err),
                        stack: err.stack
                    }
                });
                else fireAnalytics((0, $hbp6S.AnalyticsAction).FAILED, 'fetchTeamContainers', err);
                setState({
                    teamContainers: [],
                    error: err,
                    loading: false,
                    hasLoaded: true
                });
            }
        },
    refetchTeamContainers: (fireAnalytics, fireAnalyticsNext)=>async ({ setState: setState, getState: getState })=>{
            const { teamId: teamId } = getState();
            if (!teamId) return;
            try {
                const containers = await (0, $asH6r.teamsClient).getTeamContainers(teamId);
                if ((0, $dh538.fg)('ptc-enable-teams-public-analytics-refactor')) fireAnalyticsNext('operational.refetchTeamContainers.succeeded', {
                    teamId: teamId
                });
                else fireAnalytics((0, $hbp6S.AnalyticsAction).SUCCEEDED, 'refetchTeamContainers');
                // optimisation to avoid unnecessary state updates
                if (!$f181d773681f14f5$var$containersEqual(containers, getState().teamContainers)) setState({
                    teamContainers: containers,
                    loading: false,
                    error: null,
                    hasLoaded: true
                });
            } catch (err) {
                if ((0, $dh538.fg)('ptc-enable-teams-public-analytics-refactor')) fireAnalyticsNext('operational.refetchTeamContainers.failed', {
                    teamId: teamId,
                    error: {
                        message: err.message || JSON.stringify(err),
                        stack: err.stack
                    }
                });
                else fireAnalytics((0, $hbp6S.AnalyticsAction).FAILED, 'refetchTeamContainers', err);
                setState({
                    teamContainers: getState().teamContainers,
                    error: err,
                    loading: false,
                    hasLoaded: true
                });
            }
        },
    fetchNumberOfConnectedTeams: (containerId, fireAnalytics, fireAnalyticsNext)=>async ({ setState: setState, getState: getState })=>{
            const { connectedTeams: { containerId: currentContainerId } } = getState();
            if (currentContainerId === containerId) return;
            setState({
                connectedTeams: {
                    ...$f181d773681f14f5$var$initialConnectedTeamsState,
                    containerId: containerId,
                    numberOfTeams: undefined
                }
            });
            try {
                const numberOfTeams = await (0, $asH6r.teamsClient).getNumberOfConnectedTeams(containerId);
                if ((0, $dh538.fg)('ptc-enable-teams-public-analytics-refactor')) fireAnalyticsNext('operational.fetchNumberOfConnectedTeams.succeeded', {
                    numberOfTeams: numberOfTeams,
                    containerId: containerId
                });
                else fireAnalytics({
                    action: (0, $hbp6S.AnalyticsAction).SUCCEEDED,
                    actionSubject: 'fetchNumberOfConnectedTeams',
                    containerId: containerId,
                    numberOfTeams: numberOfTeams
                });
                setState({
                    connectedTeams: {
                        ...$f181d773681f14f5$var$initialConnectedTeamsState,
                        containerId: containerId,
                        numberOfTeams: numberOfTeams
                    }
                });
            } catch (e) {
                if ((0, $dh538.fg)('ptc-enable-teams-public-analytics-refactor')) fireAnalyticsNext('operational.fetchNumberOfConnectedTeams.failed', {
                    numberOfTeams: $f181d773681f14f5$var$initialConnectedTeamsState.numberOfTeams || null,
                    containerId: containerId,
                    error: {
                        message: e.message || JSON.stringify(e),
                        stack: e.stack
                    }
                });
                else fireAnalytics({
                    action: (0, $hbp6S.AnalyticsAction).FAILED,
                    actionSubject: 'fetchNumberOfConnectedTeams',
                    containerId: containerId,
                    numberOfTeams: $f181d773681f14f5$var$initialConnectedTeamsState.numberOfTeams,
                    error: e
                });
                setState({
                    connectedTeams: {
                        ...$f181d773681f14f5$var$initialConnectedTeamsState,
                        containerId: containerId,
                        error: e
                    }
                });
            }
        },
    fetchConnectedTeams: (containerId, fireAnalytics, fireAnalyticsNext)=>async ({ setState: setState, getState: getState })=>{
            const { connectedTeams: { containerId: currentContainerId, numberOfTeams: numberOfTeams, hasLoaded: hasLoaded } } = getState();
            if (currentContainerId === containerId && hasLoaded) return;
            setState({
                connectedTeams: {
                    containerId: containerId,
                    isLoading: true,
                    hasLoaded: false,
                    teams: undefined,
                    error: null,
                    numberOfTeams: numberOfTeams
                }
            });
            try {
                const teams = await (0, $asH6r.teamsClient).getConnectedTeams(containerId);
                if ((0, $dh538.fg)('ptc-enable-teams-public-analytics-refactor')) fireAnalyticsNext('operational.fetchConnectedTeams.succeeded', {
                    numberOfTeams: numberOfTeams || null,
                    containerId: containerId
                });
                else fireAnalytics({
                    action: (0, $hbp6S.AnalyticsAction).SUCCEEDED,
                    actionSubject: 'fetchConnectedTeams',
                    containerId: containerId,
                    numberOfTeams: numberOfTeams
                });
                setState({
                    connectedTeams: {
                        containerId: containerId,
                        isLoading: false,
                        hasLoaded: true,
                        teams: teams,
                        error: null,
                        numberOfTeams: numberOfTeams
                    }
                });
            } catch (e) {
                if ((0, $dh538.fg)('ptc-enable-teams-public-analytics-refactor')) fireAnalyticsNext('operational.fetchConnectedTeams.failed', {
                    numberOfTeams: numberOfTeams || null,
                    containerId: containerId,
                    error: {
                        message: e.message || JSON.stringify(e),
                        stack: e.stack
                    }
                });
                else fireAnalytics({
                    action: (0, $hbp6S.AnalyticsAction).FAILED,
                    actionSubject: 'fetchConnectedTeams',
                    containerId: containerId,
                    numberOfTeams: numberOfTeams,
                    error: e
                });
                setState({
                    connectedTeams: {
                        containerId: containerId,
                        isLoading: false,
                        hasLoaded: false,
                        teams: [],
                        error: e,
                        numberOfTeams: numberOfTeams
                    }
                });
            }
        },
    unlinkTeamContainers: (teamId, containerId)=>async ({ setState: setState, getState: getState })=>{
            setState({
                unlinkError: null
            });
            try {
                const mutationResult = await (0, $asH6r.teamsClient).unlinkTeamContainer(teamId, containerId);
                if (mutationResult.deleteTeamConnectedToContainer.errors.length) // Just handle 1 error at a time should be suffcient as we disconenct only 1 container at a time
                setState({
                    unlinkError: mutationResult.deleteTeamConnectedToContainer.errors[0]
                });
                else {
                    const { teamContainers: teamContainers, connectedTeams: connectedTeams } = getState();
                    const newContainers = teamContainers.filter((container)=>container.id !== containerId);
                    if (connectedTeams.containerId === containerId) setState({
                        teamContainers: newContainers,
                        connectedTeams: $f181d773681f14f5$var$initialConnectedTeamsState
                    });
                    else setState({
                        teamContainers: newContainers
                    });
                }
            } catch (err) {
                setState({
                    unlinkError: err
                });
            }
        },
    addTeamContainer: (teamContainer)=>async ({ setState: setState, getState: getState })=>{
            const { teamContainers: teamContainers, connectedTeams: connectedTeams } = getState();
            const containerExists = teamContainers.some((container)=>container.id === teamContainer.id);
            if (containerExists) return;
            if (connectedTeams.containerId === teamContainer.id) setState({
                teamContainers: [
                    ...teamContainers,
                    teamContainer
                ],
                connectedTeams: $f181d773681f14f5$var$initialConnectedTeamsState
            });
            else setState({
                teamContainers: [
                    ...teamContainers,
                    teamContainer
                ]
            });
        }
};
const $f181d773681f14f5$var$Store = (0, $1P1Tu.createStore)({
    initialState: $f181d773681f14f5$var$initialState,
    actions: $f181d773681f14f5$var$actions,
    name: 'teamContainersStore'
});
const $f181d773681f14f5$export$cdd1842df65e002f = (0, $9zUhf.createHook)($f181d773681f14f5$var$Store);
const $f181d773681f14f5$export$63f31a5bbbef2f9a = (teamId, enable = true)=>{
    const [state, actions] = $f181d773681f14f5$export$cdd1842df65e002f();
    const { fireOperationalEvent: fireOperationalEvent } = (0, $hbp6S.usePeopleAndTeamAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const fireOperationalAnalytics = (0, $42omo.useCallback)((action, actionSubject, error)=>{
        fireOperationalEvent(createAnalyticsEvent, {
            action: action,
            actionSubject: actionSubject,
            attributes: {
                teamId: teamId,
                ...error && {
                    error: {
                        message: error.message || JSON.stringify(error),
                        stack: error.stack
                    }
                }
            }
        });
    }, [
        fireOperationalEvent,
        createAnalyticsEvent,
        teamId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (enable) actions.fetchTeamContainers(teamId, fireOperationalAnalytics, fireEvent);
    }, [
        teamId,
        actions,
        enable,
        fireOperationalAnalytics,
        fireEvent
    ]);
    const refetchTeamContainers = (0, $42omo.useCallback)(async ()=>actions.refetchTeamContainers(fireOperationalAnalytics, fireEvent), [
        actions,
        fireOperationalAnalytics,
        fireEvent
    ]);
    return {
        ...state,
        addTeamContainer: actions.addTeamContainer,
        unlinkTeamContainers: (containerId)=>actions.unlinkTeamContainers(teamId, containerId),
        refetchTeamContainers: refetchTeamContainers
    };
};
const $f181d773681f14f5$export$aadc628af3b5ef88 = ()=>{
    const [state, actions] = $f181d773681f14f5$export$cdd1842df65e002f();
    const { fireOperationalEvent: fireOperationalEvent } = (0, $hbp6S.usePeopleAndTeamAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const fireOperationalAnalytics = (0, $42omo.useCallback)(({ action: action, actionSubject: actionSubject, containerId: containerId, numberOfTeams: numberOfTeams, error: error })=>{
        fireOperationalEvent(createAnalyticsEvent, {
            action: action,
            actionSubject: actionSubject,
            attributes: {
                containerId: containerId,
                numberOfTeams: numberOfTeams,
                ...error && {
                    error: {
                        message: error.message || JSON.stringify(error),
                        stack: error.stack
                    }
                }
            }
        });
    }, [
        fireOperationalEvent,
        createAnalyticsEvent
    ]);
    return {
        ...state.connectedTeams,
        fetchNumberOfConnectedTeams: (containerId)=>actions.fetchNumberOfConnectedTeams(containerId, fireOperationalAnalytics, fireEvent),
        fetchConnectedTeams: (containerId)=>actions.fetchConnectedTeams(containerId, fireOperationalAnalytics, fireEvent)
    };
};
module.exports["useTeamContainersHook"] = $f181d773681f14f5$export$cdd1842df65e002f;
module.exports["useTeamContainers"] = $f181d773681f14f5$export$63f31a5bbbef2f9a;
module.exports["useConnectedTeams"] = $f181d773681f14f5$export$aadc628af3b5ef88;

});

parcelRegister("aYWXT", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $521399c659dfa8b9$export$7cd9d491ff28b738 = (container)=>{
    return {
        contentTitle: container.name,
        description: '',
        linkUri: container.link || ''
    };
};
const $521399c659dfa8b9$export$34d06abc801403e2 = (link, iconData)=>{
    return {
        id: link.linkId,
        type: 'WebLink',
        name: link.contentTitle,
        icon: iconData?.iconUrl || null,
        link: link.linkUri
    };
};
const $521399c659dfa8b9$export$6a7bb6c7b84e9956 = (links, linkIcons = [])=>{
    return links.map((link)=>{
        const iconData = linkIcons.find((icon)=>icon.linkUrl === link.linkUri);
        return $521399c659dfa8b9$export$34d06abc801403e2(link, iconData);
    });
};
const $521399c659dfa8b9$export$26e8ccc2e609ae74 = (input)=>{
    return 'contentTitle' in input && 'linkUri' in input && !('type' in input) && !('id' in input);
};



var $hogmh = parcelRequire("hogmh");


var $jUUM4 = parcelRequire("jUUM4");

const $18f36a201d3ef90d$var$MAX_LINKS_LIMIT = 10;
const $18f36a201d3ef90d$export$5200d5ff4aebd4a7 = (teamId, enableContainers = true)=>{
    const { teamContainers: teamContainers, loading: containersLoading, hasLoaded: containersHasLoaded, error: containersError, addTeamContainer: addTeamContainer, unlinkTeamContainers: unlinkTeamContainers } = (0, $hogmh.useTeamContainers)(teamId, enableContainers);
    const [{ links: links, linkIcons: linkIcons, isLoading: webLinksLoading, hasError: webLinksError, hasLoaded: webLinksHasLoaded, iconsLoading: iconsLoading, iconHasLoaded: iconHasLoaded }, { getTeamWebLinks: getTeamWebLinks, createTeamWebLink: createTeamWebLink, updateTeamWebLink: updateTeamWebLink, removeWebLink: removeWebLink }] = (0, $jUUM4.useTeamWebLinks)();
    (0, $42omo.useEffect)(()=>{
        getTeamWebLinks(teamId);
    }, [
        getTeamWebLinks,
        teamId
    ]);
    const webLinkContainers = (0, $42omo.useMemo)(()=>(0, $521399c659dfa8b9$export$6a7bb6c7b84e9956)(links, linkIcons), [
        links,
        linkIcons
    ]);
    const allContainers = (0, $42omo.useMemo)(()=>[
            ...teamContainers,
            ...webLinkContainers
        ], [
        teamContainers,
        webLinkContainers
    ]);
    const canAddMoreLink = (0, $42omo.useMemo)(()=>allContainers.length < $18f36a201d3ef90d$var$MAX_LINKS_LIMIT, [
        allContainers.length
    ]);
    const addTeamLink = (0, $42omo.useCallback)(async (containerOrWebLink)=>{
        if ((0, $521399c659dfa8b9$export$26e8ccc2e609ae74)(containerOrWebLink)) return await createTeamWebLink(teamId, containerOrWebLink);
        else if (containerOrWebLink.type === 'WebLink') {
            const webLink = (0, $521399c659dfa8b9$export$7cd9d491ff28b738)(containerOrWebLink);
            return await createTeamWebLink(teamId, webLink);
        } else {
            addTeamContainer(containerOrWebLink);
            return Promise.resolve(containerOrWebLink);
        }
    }, [
        teamId,
        createTeamWebLink,
        addTeamContainer
    ]);
    const updateTeamLinkById = (0, $42omo.useCallback)(async (linkId, updatedFields)=>{
        const container = allContainers.find((link)=>link.id === linkId);
        if (!container) return;
        if (container.type === 'WebLink') {
            const currentWebLink = (0, $521399c659dfa8b9$export$7cd9d491ff28b738)(container);
            const updatedWebLink = {
                ...currentWebLink,
                ...updatedFields
            };
            return await updateTeamWebLink(teamId, linkId, updatedWebLink);
        }
    }, [
        teamId,
        allContainers,
        updateTeamWebLink
    ]);
    const removeTeamLink = (0, $42omo.useCallback)(async (container)=>{
        if (container.type === 'WebLink') await removeWebLink(teamId, container.id);
        else await unlinkTeamContainers(container.id);
    }, [
        teamId,
        removeWebLink,
        unlinkTeamContainers
    ]);
    return {
        isLoading: containersLoading || webLinksLoading,
        hasError: !!containersError || webLinksError,
        containersError: !!containersError,
        webLinksError: webLinksError,
        containersHasLoaded: containersHasLoaded,
        webLinksHasLoaded: webLinksHasLoaded,
        hasLoaded: containersHasLoaded && webLinksHasLoaded,
        teamLinks: allContainers,
        canAddMoreLink: canAddMoreLink,
        iconsLoading: iconsLoading,
        iconHasLoaded: iconHasLoaded,
        addTeamLink: addTeamLink,
        updateTeamLinkById: updateTeamLinkById,
        removeTeamLink: removeTeamLink
    };
};
module.exports["useTeamLinksAndContainers"] = $18f36a201d3ef90d$export$5200d5ff4aebd4a7;

});

parcelRegister("jUUM4", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $dh538 = parcelRequire("dh538");


var $asH6r = parcelRequire("asH6r");

const $e5eadcc240b15d46$var$initialState = {
    teamId: '',
    isLoading: false,
    hasLoaded: false,
    hasError: false,
    shouldReload: false,
    errorType: null,
    links: [],
    linkIcons: [],
    iconsLoading: false,
    iconsError: false,
    iconHasLoaded: false
};
const $e5eadcc240b15d46$export$e324594224ef24da = {
    getTeamWebLinks: (teamId)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { links: links, teamId: currentTeamId, hasLoaded: hasLoaded, isLoading: isLoading } = getState();
            if ((isLoading || teamId === currentTeamId && hasLoaded && links.length > 0) && (0, $dh538.fg)('prevent_parallel_team_web_links_fetch')) return;
            const initialLinks = teamId === currentTeamId ? links : [];
            setState({
                teamId: teamId,
                isLoading: true,
                hasLoaded: false,
                hasError: false,
                shouldReload: false,
                links: initialLinks
            });
            try {
                const { entities: entities } = await (0, $asH6r.teamsClient).getTeamLinksByTeamId(teamId);
                if (getState().teamId !== teamId) return;
                setState({
                    isLoading: false,
                    hasLoaded: true,
                    hasError: false,
                    shouldReload: false,
                    links: entities
                });
                if (entities.length > 0) dispatch($e5eadcc240b15d46$export$e324594224ef24da.getTeamWebLinkIcons(teamId));
            } catch (e) {
                if (getState().teamId !== teamId) return;
                setState({
                    isLoading: false,
                    hasLoaded: true,
                    hasError: true,
                    errorType: e instanceof Error ? e : undefined,
                    shouldReload: false,
                    links: []
                });
            }
        },
    getTeamWebLinkIcons: (teamId)=>async ({ getState: getState, setState: setState })=>{
            const { links: links, linkIcons: currentIcons } = getState();
            if (links.length === 0) return;
            const linkUrls = links.map((link)=>link.linkUri);
            const uncachedUrls = linkUrls.filter((url)=>!currentIcons.some((icon)=>icon.linkUrl === url));
            if (uncachedUrls.length > 0) try {
                setState({
                    iconsLoading: true,
                    iconsError: false
                });
                const newIconData = await (0, $asH6r.teamsClient).getTeamLinkIcons(uncachedUrls);
                if (getState().teamId === teamId) setState({
                    linkIcons: [
                        ...currentIcons,
                        ...newIconData || []
                    ],
                    iconsLoading: false,
                    iconsError: false,
                    iconHasLoaded: true
                });
            } catch (iconError) {
                if (getState().teamId === teamId) setState({
                    iconsLoading: false,
                    iconsError: true,
                    iconHasLoaded: true
                });
            }
            else setState({
                iconsLoading: false,
                iconsError: false,
                iconHasLoaded: true
            });
        },
    createTeamWebLink: (teamId, newLink)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const result = await (0, $asH6r.teamsClient).createTeamLink(teamId, newLink);
            const currentState = getState();
            if (currentState.teamId !== teamId) return result;
            setState({
                links: [
                    ...currentState.links,
                    result
                ]
            });
            dispatch($e5eadcc240b15d46$export$e324594224ef24da.getTeamWebLinkIcons(teamId));
            return result;
        },
    updateTeamWebLink: (teamId, linkId, newLink)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const result = await (0, $asH6r.teamsClient).updateTeamLink(teamId, linkId, newLink);
            const currentState = getState();
            if (currentState.teamId !== teamId) return result;
            const oldLink = currentState.links.find((link)=>link.linkId === linkId);
            const urlChanged = oldLink && oldLink.linkUri !== result.linkUri;
            setState({
                links: currentState.links.map((link)=>link.linkId === linkId ? result : link)
            });
            if (urlChanged) {
                const updatedIcons = currentState.linkIcons.filter((icon)=>icon.linkUrl !== oldLink.linkUri);
                setState({
                    linkIcons: updatedIcons
                });
                dispatch($e5eadcc240b15d46$export$e324594224ef24da.getTeamWebLinkIcons(teamId));
            }
            return result;
        },
    removeWebLink: (teamId, linkId)=>async ({ getState: getState, setState: setState })=>{
            const currentState = getState();
            if (currentState.teamId !== teamId) return;
            await (0, $asH6r.teamsClient).deleteTeamLink(teamId, linkId);
            setState({
                links: currentState.links.filter((link)=>link.linkId !== linkId)
            });
        },
    fetchWebLinkTitle: (url)=>async ({ setState: _setState })=>{
            if (!url) return undefined;
            try {
                const title = await (0, $asH6r.teamsClient).getWebLinkTitle(url);
                return title;
            } catch (error) {
                return undefined;
            }
        },
    initialState: (state)=>({ setState: setState })=>{
            setState({
                ...$e5eadcc240b15d46$var$initialState,
                ...state
            });
        }
};
const $e5eadcc240b15d46$var$TeamWebLinksStore = (0, $1P1Tu.createStore)({
    initialState: $e5eadcc240b15d46$var$initialState,
    actions: $e5eadcc240b15d46$export$e324594224ef24da
});
const $e5eadcc240b15d46$export$72df01179a70062e = (0, $9zUhf.createHook)($e5eadcc240b15d46$var$TeamWebLinksStore);
const $e5eadcc240b15d46$export$e1403f4f298df7e3 = (0, $9zUhf.createHook)($e5eadcc240b15d46$var$TeamWebLinksStore, {
    selector: null
});
module.exports["useTeamWebLinks"] = $e5eadcc240b15d46$export$72df01179a70062e;
module.exports["useTeamWebLinksActions"] = $e5eadcc240b15d46$export$e1403f4f298df7e3;

});

parcelRegister("chP7f", function(module, exports) {

let $8f1eb924c69f852d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8f1eb924c69f852d$var$load("hfT7k").then(()=>parcelRequire('lvs8O'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("6l0gG", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $1qfLF = parcelRequire("1qfLF");


var $1Whri = parcelRequire("1Whri");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $c6GJD = parcelRequire("c6GJD");


var $hmuev = parcelRequire("hmuev");


var $8tdj3 = parcelRequire("8tdj3");


var $9VJDA = parcelRequire("9VJDA");


var $2Nwuj = parcelRequire("2Nwuj");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $fDXXi = parcelRequire("fDXXi");


var $3gadb = parcelRequire("3gadb");


var $bnTdW = parcelRequire("bnTdW");


var $jOrEm = parcelRequire("jOrEm");


var $2OhPQ = parcelRequire("2OhPQ");


var $hbp6S = parcelRequire("hbp6S");


var $31Vvl = parcelRequire("31Vvl");


var $eh61z = parcelRequire("eh61z");


var $kMNTc = parcelRequire("kMNTc");

/* team-link-card-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");






const $1d54835e6da1382c$var$styles = {
    anchorWithUnderline: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo"
};
const $1d54835e6da1382c$export$ed2948fef4767d5d = ({ isTeamLensInHomeEnabled: isTeamLensInHomeEnabled, isOpenWebLinkInNewTabEnabled: isOpenWebLinkInNewTabEnabled, link: link = '#', handleLinkClick: handleLinkClick, title: title })=>{
    return isTeamLensInHomeEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        xcss: $1d54835e6da1382c$var$styles.anchorWithUnderline,
        href: link,
        onClick: handleLinkClick,
        testId: "team-link-card-linkable-content",
        target: isOpenWebLinkInNewTabEnabled ? '_blank' : '_self',
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            maxLines: 1,
            weight: "medium",
            color: "color.text",
            children: title
        })
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
        maxLines: 1,
        weight: "medium",
        color: "color.text",
        children: title
    });
};


const $cef8474127ba13ca$var$styles = {
    container: "_2rkoy0do _1h6d8yml _12y3e4h9 _12ji1l7x _1qu2nqa1 _ca0qutpp _u5f3pxbi _n3tdutpp _19bvpxbi _syazi7uo _bfhkhp5a _irr319i6",
    card: "_4cvr1h6o _1bsb1osq",
    anchor: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _2rkoy0do _1bsb1osq _syazi7uo _1053i7uo _1hvwdkaa _nt751v1w _49pcnqa1 _1bg4v77o _30l3i7uo",
    anchorNoUnderline: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _30l3i7uo",
    anchorWithExternalLinkIcon: "_1e0c1txw _4cvr1h6o _1bah1yb4",
    iconWrapper: "_1bsbzwfg _4t3izwfg _1ul9zwfg _1tkezwfg",
    crossIconWrapper: "_1e0c1txw _4cvr1h6o _1bahesu3 _18u01wug",
    showMoreIconWrapper: "_1e0c1txw _4cvr1h6o _1bahesu3 _18u01wug",
    linkableContent: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    externalLinkIconWrapper: "_1e0c1txw _4cvr1h6o _1bahesu3 _18u0u2gc"
};
const $cef8474127ba13ca$var$renderContainerTypeTextWithSeparator = (containerTypeText, description)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            containerTypeText && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtle",
                children: containerTypeText
            }),
            containerTypeText && description && /*#__PURE__*/ (0, $l998X.jsx)((0, $jOrEm.Separator), {}),
            description && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtle",
                children: description
            })
        ]
    });
};
const $cef8474127ba13ca$export$281f9ee6597a4098 = ({ containerType: containerType, title: title, containerIcon: containerIcon, link: link, containerId: containerId, containerTypeProperties: containerTypeProperties, onDisconnectButtonClick: onDisconnectButtonClick, onEditLinkClick: onEditLinkClick, iconsLoading: iconsLoading, iconHasLoaded: iconHasLoaded, openInNewTab: openInNewTab, isReadOnly: isReadOnly, hideSubTextIcon: hideSubTextIcon })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { description: description, icon: icon, containerTypeText: containerTypeText } = (0, $31Vvl.getContainerProperties)({
        containerType: containerType,
        iconSize: 'medium',
        containerTypeProperties: containerTypeProperties
    });
    const [hovered, setHovered] = (0, $42omo.useState)(false);
    const [focused, setFocused] = (0, $42omo.useState)(false);
    const [showCloseIcon, setShowCloseIcon] = (0, $42omo.useState)(false);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $42omo.useState)(false);
    const [showKeyboardFocus, setShowKeyboardFocus] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { fireUIEvent: fireUIEvent } = (0, $hbp6S.usePeopleAndTeamAnalytics)();
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const isTeamLensInHomeEnabled = (0, $eh61z.getIsExperimentEnabled)('team_lens_in_atlassian_home');
    const isNewTeamProfilePageEnabled = (0, $c6GJD.default).getExperimentValue('new_team_profile', 'isEnabled', false);
    const isOpenWebLinkInNewTabEnabled = containerType === 'WebLink' && (isNewTeamProfilePageEnabled || isTeamLensInHomeEnabled);
    const handleMouseEnter = ()=>{
        if (isReadOnly) return;
        setHovered(true);
        if (containerType !== 'WebLink') setShowCloseIcon(true);
    };
    const handleFocus = ()=>{
        if (isReadOnly) return;
        setFocused(true);
        if (containerType !== 'WebLink') setShowCloseIcon(true);
    };
    const handleBlur = ()=>{
        setFocused(false);
        if (containerType !== 'WebLink' && !hovered) setShowCloseIcon(false);
    };
    const handleMouseLeave = ()=>{
        setHovered(false);
        if (containerType !== 'WebLink' && !focused) setShowCloseIcon(false);
    };
    const handleIconClick = ()=>{
        if ((0, $dh538.fg)('fix_team_link_card_a11y')) setShowKeyboardFocus(false);
    };
    const handleKeyDown = (e)=>{
        if ((e.key === 'Enter' || e.key === ' ' || e.key === 'Tab' || e.key === 'Escape') && (0, $dh538.fg)('fix_team_link_card_a11y')) setShowKeyboardFocus(true);
    };
    const handleLinkClick = (e)=>{
        e.stopPropagation();
        const baseAttributes = {
            container: containerType,
            containerId: containerId
        };
        const attributes = containerType === 'WebLink' && link ? {
            containerSelected: {
                ...baseAttributes,
                linkDomain: (0, $kMNTc.getDomainFromLinkUri)(link)
            }
        } : {
            containerSelected: baseAttributes
        };
        if ((0, $dh538.fg)('ptc-enable-teams-public-analytics-refactor')) fireEvent('ui.container.clicked.teamContainer', attributes);
        else fireUIEvent(createAnalyticsEvent, {
            action: (0, $hbp6S.AnalyticsAction).CLICKED,
            actionSubject: 'container',
            actionSubjectId: 'teamContainer',
            attributes: attributes
        });
        if (openInNewTab || isOpenWebLinkInNewTabEnabled) {
            e.preventDefault();
            window.open(link || '#', '_blank', 'noopener, noreferrer');
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $cef8474127ba13ca$var$styles.container,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onKeyDown: handleKeyDown,
        testId: "team-link-card-inner",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.150",
            xcss: $cef8474127ba13ca$var$styles.card,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $bnTdW.ContainerIcon), {
                    containerType: containerType,
                    title: title,
                    containerIcon: containerIcon,
                    size: "medium",
                    iconsLoading: iconsLoading,
                    iconHasLoaded: iconHasLoaded
                }),
                (0, $dh538.fg)('fix_team_link_card_a11y') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default), {
                            xcss: (0, $1Whri.cx)($cef8474127ba13ca$var$styles.anchor, isTeamLensInHomeEnabled && $cef8474127ba13ca$var$styles.anchorNoUnderline, isOpenWebLinkInNewTabEnabled && $cef8474127ba13ca$var$styles.anchorWithExternalLinkIcon),
                            href: link || '#',
                            onClick: handleLinkClick,
                            testId: "team-link-card-linkable-content",
                            target: isOpenWebLinkInNewTabEnabled ? '_blank' : '_self',
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1d54835e6da1382c$export$ed2948fef4767d5d), {
                                            isTeamLensInHomeEnabled: isTeamLensInHomeEnabled,
                                            isOpenWebLinkInNewTabEnabled: isOpenWebLinkInNewTabEnabled,
                                            link: link || '#',
                                            handleLinkClick: handleLinkClick,
                                            title: title
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                            gap: "space.050",
                                            alignItems: "center",
                                            children: [
                                                !hideSubTextIcon ? icon : null,
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                                                    space: "space.050",
                                                    alignBlock: "center",
                                                    children: isNewTeamProfilePageEnabled || isTeamLensInHomeEnabled ? $cef8474127ba13ca$var$renderContainerTypeTextWithSeparator(containerTypeText, description) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                                size: "small",
                                                                color: "color.text.subtle",
                                                                children: description
                                                            }),
                                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                                size: "small",
                                                                color: "color.text.subtle",
                                                                children: containerTypeText
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                isOpenWebLinkInNewTabEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $cef8474127ba13ca$var$styles.externalLinkIconWrapper,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                                        label: formatMessage($cef8474127ba13ca$var$messages.linkExternalIconLabel),
                                        "aria-hidden": "true",
                                        size: "small"
                                    })
                                })
                            ]
                        }),
                        !isReadOnly && /*#__PURE__*/ (0, $l998X.jsx)((0, $2OhPQ.TeamLinkCardActions), {
                            containerType: containerType,
                            title: title,
                            containerId: containerId,
                            hovered: hovered,
                            focused: focused,
                            isDropdownOpen: isDropdownOpen,
                            showKeyboardFocus: showKeyboardFocus,
                            onDisconnectButtonClick: ()=>{
                                handleIconClick();
                                onDisconnectButtonClick();
                            },
                            onEditLinkClick: ()=>{
                                handleIconClick();
                                onEditLinkClick?.();
                            },
                            onDropdownOpenChange: setIsDropdownOpen
                        })
                    ]
                }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $cef8474127ba13ca$var$styles.linkableContent,
                            testId: "team-link-card-linkable-content",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                href: link || '#',
                                appearance: "subtle",
                                onClick: handleLinkClick,
                                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1d54835e6da1382c$export$ed2948fef4767d5d), {
                                            isTeamLensInHomeEnabled: isTeamLensInHomeEnabled,
                                            isOpenWebLinkInNewTabEnabled: isOpenWebLinkInNewTabEnabled,
                                            link: link || '#',
                                            handleLinkClick: handleLinkClick,
                                            title: title
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                            gap: "space.050",
                                            alignItems: "center",
                                            children: [
                                                !hideSubTextIcon ? icon : null,
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                                                    space: "space.050",
                                                    alignBlock: "center",
                                                    children: isNewTeamProfilePageEnabled || isTeamLensInHomeEnabled ? $cef8474127ba13ca$var$renderContainerTypeTextWithSeparator(containerTypeText, description) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                                size: "small",
                                                                color: "color.text.subtle",
                                                                children: description
                                                            }),
                                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                                size: "small",
                                                                color: "color.text.subtle",
                                                                children: containerTypeText
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        showCloseIcon && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $cef8474127ba13ca$var$styles.crossIconWrapper,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                                content: formatMessage($cef8474127ba13ca$var$messages.disconnectTooltip),
                                position: "top",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                    label: `disconnect the container ${title}`,
                                    appearance: "subtle",
                                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                            ...iconProps,
                                            size: "small"
                                        }),
                                    spacing: "compact",
                                    onClick: (e)=>{
                                        e.preventDefault();
                                        e.stopPropagation();
                                        onDisconnectButtonClick();
                                        if ((0, $dh538.fg)('ptc-enable-teams-public-analytics-refactor')) fireEvent('ui.button.clicked.containerUnlinkButton', {
                                            containerSelected: {
                                                container: containerType,
                                                containerId: containerId
                                            }
                                        });
                                        else fireUIEvent(createAnalyticsEvent, {
                                            action: (0, $hbp6S.AnalyticsAction).CLICKED,
                                            actionSubject: 'button',
                                            actionSubjectId: 'containerUnlinkButton',
                                            attributes: {
                                                containerSelected: {
                                                    container: containerType,
                                                    containerId: containerId
                                                }
                                            }
                                        });
                                    }
                                })
                            })
                        }),
                        containerType === 'WebLink' && (hovered || isDropdownOpen) && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $cef8474127ba13ca$var$styles.showMoreIconWrapper,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
                                trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                        ref: triggerRef,
                                        ...triggerProps,
                                        label: `more options for ${title}`,
                                        appearance: "subtle",
                                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                                                ...iconProps,
                                                size: "small"
                                            }),
                                        spacing: "compact"
                                    }),
                                placement: "bottom-end",
                                shouldRenderToParent: true,
                                onOpenChange: (attrs)=>{
                                    setIsDropdownOpen(attrs.isOpen);
                                },
                                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $ahaN7.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                e.stopPropagation();
                                                onEditLinkClick?.();
                                                if ((0, $dh538.fg)('ptc-enable-teams-public-analytics-refactor')) fireEvent('ui.button.clicked.containerEditLinkButton', {
                                                    containerSelected: {
                                                        container: containerType,
                                                        containerId: containerId
                                                    }
                                                });
                                                else fireUIEvent(createAnalyticsEvent, {
                                                    action: (0, $hbp6S.AnalyticsAction).CLICKED,
                                                    actionSubject: 'button',
                                                    actionSubjectId: 'containerEditLinkButton',
                                                    attributes: {
                                                        containerSelected: {
                                                            container: containerType,
                                                            containerId: containerId
                                                        }
                                                    }
                                                });
                                            },
                                            children: formatMessage($cef8474127ba13ca$var$messages.editLink)
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                e.stopPropagation();
                                                onDisconnectButtonClick();
                                                if ((0, $dh538.fg)('ptc-enable-teams-public-analytics-refactor')) fireEvent('ui.button.clicked.containerUnlinkButton', {
                                                    containerSelected: {
                                                        container: containerType,
                                                        containerId: containerId
                                                    }
                                                });
                                                else fireUIEvent(createAnalyticsEvent, {
                                                    action: (0, $hbp6S.AnalyticsAction).CLICKED,
                                                    actionSubject: 'button',
                                                    actionSubjectId: 'containerUnlinkButton',
                                                    attributes: {
                                                        containerSelected: {
                                                            container: containerType,
                                                            containerId: containerId
                                                        }
                                                    }
                                                });
                                            },
                                            children: formatMessage($cef8474127ba13ca$var$messages.removeLink)
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $cef8474127ba13ca$var$messages = (0, $cgtv4.defineMessages)({
    disconnectTooltip: {
        id: "ptc-directory.team-containers.disconnect-button.tooltip",
        defaultMessage: "Disconnect"
    },
    editLink: {
        id: "ptc-directory.team-containers.edit-link",
        defaultMessage: "Edit link"
    },
    removeLink: {
        id: "ptc-directory.team-containers.remove-link",
        defaultMessage: "Remove"
    },
    linkExternalIconLabel: {
        id: "ptc-directory.team-containers.link-external-icon-label",
        defaultMessage: "Open link in new tab"
    }
});
module.exports["TeamLinkCard"] = $cef8474127ba13ca$export$281f9ee6597a4098;

});

parcelRegister("bnTdW", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $1qfLF = parcelRequire("1qfLF");


var $1Whri = parcelRequire("1Whri");


var $c6GJD = parcelRequire("c6GJD");


var $buthI = parcelRequire("buthI");


var $1bY7o = parcelRequire("1bY7o");


var $gdv5Z = parcelRequire("gdv5Z");


var $eh61z = parcelRequire("eh61z");


var $5KpJQ = parcelRequire("5KpJQ");

const $cdbd58dfaa7da816$var$styles = {
    globeIconWrapperMedium: "_2rko1mok _1bsb1u1b _4t3i1u1b _1e0c1txw _4cvr1h6o _1bah1h6o _12ji1l7x _1qu2nqa1 _bfhkhfxm",
    globeIconWrapperSmall: "_2rkolb4i _1ul91tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _12ji1l7x _1qu2nqa1 _bfhkhfxm",
    linkIconWrapperSmall: "_19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
    skeletonMedium: "_2rko1mok _bfhkizff _1bsb1u1b _4t3i1u1b",
    skeletonSmall: "_2rkolb4i _bfhkizff _1bsb1tcg _4t3i1tcg"
};
const $cdbd58dfaa7da816$var$IconSkeleton = ({ size: size })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: size === 'medium' ? $cdbd58dfaa7da816$var$styles.skeletonMedium : $cdbd58dfaa7da816$var$styles.skeletonSmall,
        testId: "container-icon-skeleton"
    });
};
const $cdbd58dfaa7da816$export$6d6da6edaddd5876 = ({ containerType: containerType, title: title, containerIcon: containerIcon, size: size = 'medium', iconsLoading: iconsLoading = false, iconHasLoaded: iconHasLoaded = true })=>{
    const isMedium = size === 'medium';
    const isTeamLensInHomeEnabled = (0, $eh61z.getIsExperimentEnabled)('team_lens_in_atlassian_home');
    const isNewTeamProfilePageEnabled = (0, $c6GJD.default).getExperimentValue('new_team_profile', 'isEnabled', false);
    if (containerType === 'LoomSpace') return /*#__PURE__*/ (0, $l998X.jsx)((0, $5KpJQ.LoomSpaceAvatar), {
        spaceName: title,
        size: isMedium ? 'large' : size,
        testId: `linked-container-${containerType}-icon`
    });
    // This is a fallback icon for WebLink if the containerIcon is not present
    if (containerType === 'WebLink' && !containerIcon) {
        if (isTeamLensInHomeEnabled || isNewTeamProfilePageEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)(!isMedium && $cdbd58dfaa7da816$var$styles.linkIconWrapperSmall),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                label: "",
                spacing: isMedium ? 'default' : 'compact',
                appearance: "default",
                "aria-hidden": "true",
                tabIndex: -1,
                testId: "linked-container-WebLink-new-icon",
                icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                        label: "",
                        size: isMedium ? 'medium' : 'small'
                    })
            })
        });
        if (iconsLoading || !iconHasLoaded) return /*#__PURE__*/ (0, $l998X.jsx)($cdbd58dfaa7da816$var$IconSkeleton, {
            size: size
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: isMedium ? $cdbd58dfaa7da816$var$styles.globeIconWrapperMedium : $cdbd58dfaa7da816$var$styles.globeIconWrapperSmall,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), {
                label: "",
                testId: "linked-container-WebLink-icon"
            })
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
        appearance: "square",
        borderColor: "transparent",
        size: size,
        src: containerIcon,
        testId: `linked-container-${containerType}-icon`
    });
};
module.exports["ContainerIcon"] = $cdbd58dfaa7da816$export$6d6da6edaddd5876;

});

parcelRegister("5KpJQ", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $26c57f7c46c41cfd$exports = {};
"use strict";
function $26c57f7c46c41cfd$var$hash(str) {
    var hash = 5381, i = str.length;
    while(i)hash = hash * 33 ^ str.charCodeAt(--i);
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return hash >>> 0;
}
$26c57f7c46c41cfd$exports = $26c57f7c46c41cfd$var$hash;


var $e0c49377f9432a00$var$SpaceColors = /*#__PURE__*/ function(SpaceColors) {
    SpaceColors["ORANGE_LIGHT"] = "#FFD5D2";
    SpaceColors["BLUE_LIGHT"] = "#CFE1FD";
    SpaceColors["YELLOW_LIGHT"] = "#FCE4A6";
    SpaceColors["TEAL"] = "#BAF3DB";
    return SpaceColors;
}($e0c49377f9432a00$var$SpaceColors || {});
var $e0c49377f9432a00$var$AvatarTextColors = /*#__PURE__*/ function(AvatarTextColors) {
    AvatarTextColors["ORANGE_DARK"] = "#AE2E24";
    AvatarTextColors["BLUE_DARK"] = "#123263";
    AvatarTextColors["YELLOW_DARK"] = "#9E4C00";
    AvatarTextColors["TEAL_DARK"] = "#164B35";
    return AvatarTextColors;
}($e0c49377f9432a00$var$AvatarTextColors || {});
const $e0c49377f9432a00$var$AVATAR_CONTAINER_COLORS = [
    "#FFD5D2",
    "#CFE1FD",
    "#FCE4A6",
    "#BAF3DB"
];
const $e0c49377f9432a00$var$AVATAR_TEXT_COLORS = [
    "#AE2E24",
    "#123263",
    "#9E4C00",
    "#164B35"
];
const $e0c49377f9432a00$var$hash = (str)=>{
    let hash = $26c57f7c46c41cfd$exports(str);
    hash = ~hash;
    return Math.abs(Number(hash));
};
const $e0c49377f9432a00$export$a3b2d23d4cacf752 = (spaceName)=>{
    return spaceName?.trim().length ? spaceName.trim()[0].toUpperCase() : '';
};
const $e0c49377f9432a00$export$55185ae96e679e0a = (spaceName)=>{
    const avatarHash = $e0c49377f9432a00$var$hash(spaceName);
    return $e0c49377f9432a00$var$AVATAR_CONTAINER_COLORS[avatarHash % $e0c49377f9432a00$var$AVATAR_CONTAINER_COLORS.length];
};
const $e0c49377f9432a00$export$7063fff24f5d2ae7 = (spaceName)=>{
    const avatarHash = $e0c49377f9432a00$var$hash(spaceName);
    return $e0c49377f9432a00$var$AVATAR_TEXT_COLORS[avatarHash % $e0c49377f9432a00$var$AVATAR_TEXT_COLORS.length];
};


const $a45374652d92ddd7$var$boxStyle = null;
const $a45374652d92ddd7$var$smallBoxStyle = null;
const $a45374652d92ddd7$var$largeBoxStyle = null;
function $a45374652d92ddd7$export$6055fe3c3d07f8d9({ spaceName: spaceName = '', size: size = 'small', testId: testId = '' }) {
    const avatarText = (0, $e0c49377f9432a00$export$a3b2d23d4cacf752)(spaceName);
    const containerColor = (0, $e0c49377f9432a00$export$55185ae96e679e0a)(spaceName);
    const textColor = (0, $e0c49377f9432a00$export$7063fff24f5d2ae7)(spaceName);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            backgroundColor: containerColor,
            color: textColor
        },
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _4cvr1h6o _1bah1h6o",
            size === 'small' ? "_11c81qyo _4t3iqslr _1ul9qslr _19pkv77o _2hwxv77o _otyrv77o _18u0v77o" : "_11c81af2 _18zrv77o _4t3izwfg _1bsbzwfg"
        ]),
        children: avatarText
    });
}
module.exports["LoomSpaceAvatar"] = $a45374652d92ddd7$export$6055fe3c3d07f8d9;

});

parcelRegister("jOrEm", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");

const $b1a6c04f3d83017d$var$styles = {
    separator: "_t9ec18p1"
};
const $b1a6c04f3d83017d$var$SEPARATOR = "\u2022";
const $b1a6c04f3d83017d$export$1ff3c3f08ae963c0 = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        xcss: $b1a6c04f3d83017d$var$styles.separator,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtle",
            children: $b1a6c04f3d83017d$var$SEPARATOR
        })
    });
module.exports["Separator"] = $b1a6c04f3d83017d$export$1ff3c3f08ae963c0;

});

parcelRegister("2OhPQ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $1qfLF = parcelRequire("1qfLF");


var $1Whri = parcelRequire("1Whri");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $hmuev = parcelRequire("hmuev");


var $9VJDA = parcelRequire("9VJDA");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $fDXXi = parcelRequire("fDXXi");


var $3gadb = parcelRequire("3gadb");


var $hbp6S = parcelRequire("hbp6S");

const $f4b036555297915a$var$styles = {
    crossIconWrapper: "_1e0c1txw _4cvr1h6o _1bahesu3 _18u01wug",
    showMoreIconWrapper: "_1e0c1txw _4cvr1h6o _1bahesu3 _18u01wug",
    iconHidden: "_1e0cglyw",
    iconVisible: "_1e0c1txw"
};
const $f4b036555297915a$var$messages = (0, $cgtv4.defineMessages)({
    disconnectTooltip: {
        id: "ptc-directory.team-containers.disconnect-button.tooltip",
        defaultMessage: "Disconnect"
    },
    editLink: {
        id: "ptc-directory.team-containers.edit-link",
        defaultMessage: "Edit link"
    },
    removeLink: {
        id: "ptc-directory.team-containers.remove-link",
        defaultMessage: "Remove"
    }
});
const $f4b036555297915a$export$7f8ec3a4a0c86d35 = ({ containerType: containerType, title: title, containerId: containerId, hovered: hovered, focused: focused, isDropdownOpen: isDropdownOpen, showKeyboardFocus: showKeyboardFocus, onDisconnectButtonClick: onDisconnectButtonClick, onEditLinkClick: onEditLinkClick, onDropdownOpenChange: onDropdownOpenChange })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { fireUIEvent: fireUIEvent } = (0, $hbp6S.usePeopleAndTeamAnalytics)();
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)(); // Show icons when:
    // 1. Hovering over the card
    // 2. Dropdown is open
    // 3. Focused via keyboard navigation (when showKeyboardFocus is true)
    const shouldShowIcon = hovered || isDropdownOpen || focused && showKeyboardFocus;
    const handleDisconnectClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        onDisconnectButtonClick();
        if ((0, $dh538.fg)('ptc-enable-teams-public-analytics-refactor')) fireEvent('ui.button.clicked.containerUnlinkButton', {
            containerSelected: {
                container: containerType,
                containerId: containerId
            }
        });
        else fireUIEvent(createAnalyticsEvent, {
            action: (0, $hbp6S.AnalyticsAction).CLICKED,
            actionSubject: 'button',
            actionSubjectId: 'containerUnlinkButton',
            attributes: {
                containerSelected: {
                    container: containerType,
                    containerId: containerId
                }
            }
        });
    };
    const handleEditLinkClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        onEditLinkClick?.();
        if ((0, $dh538.fg)('ptc-enable-teams-public-analytics-refactor')) fireEvent('ui.button.clicked.containerEditLinkButton', {
            containerSelected: {
                container: containerType,
                containerId: containerId
            }
        });
        else fireUIEvent(createAnalyticsEvent, {
            action: (0, $hbp6S.AnalyticsAction).CLICKED,
            actionSubject: 'button',
            actionSubjectId: 'containerEditLinkButton',
            attributes: {
                containerSelected: {
                    container: containerType,
                    containerId: containerId
                }
            }
        });
    };
    if (containerType === 'WebLink') return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($f4b036555297915a$var$styles.showMoreIconWrapper, shouldShowIcon ? $f4b036555297915a$var$styles.iconVisible : $f4b036555297915a$var$styles.iconHidden),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    ref: triggerRef,
                    ...triggerProps,
                    label: `more options for ${title}`,
                    appearance: "subtle",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                            ...iconProps,
                            size: "small"
                        }),
                    spacing: "compact"
                }),
            placement: "bottom-end",
            shouldRenderToParent: true,
            onOpenChange: (attrs)=>{
                onDropdownOpenChange(attrs.isOpen);
            },
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $ahaN7.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                        onClick: handleEditLinkClick,
                        children: formatMessage($f4b036555297915a$var$messages.editLink)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                        onClick: handleDisconnectClick,
                        children: formatMessage($f4b036555297915a$var$messages.removeLink)
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($f4b036555297915a$var$styles.crossIconWrapper, shouldShowIcon ? $f4b036555297915a$var$styles.iconVisible : $f4b036555297915a$var$styles.iconHidden),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
            content: formatMessage($f4b036555297915a$var$messages.disconnectTooltip),
            position: "top",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                label: `disconnect the container ${title}`,
                appearance: "subtle",
                icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                        ...iconProps,
                        size: "small"
                    }),
                spacing: "compact",
                onClick: handleDisconnectClick
            })
        })
    });
};
module.exports["TeamLinkCardActions"] = $f4b036555297915a$export$7f8ec3a4a0c86d35;

});

parcelRegister("kMNTc", function(module, exports) {
/**
 * Extract the domain from the URL. Strips "www" subdomains
 * e.g. http://dogs.animals.com/yellow/golden-retriever becomes "dogs.animals.com"
 * e.g. http://www.blake.com/memes becomes "blake.com"
 *
 * Return an empty string if a totally invalid url is somehow passed in.
 * @param url
 */ const $1c729a8c68a0370e$export$cda14c9dfe45538 = (url)=>{
    let hostname;
    try {
        try {
            hostname = $1c729a8c68a0370e$export$eb5a321f13bbb969(url);
        } catch (noProtocolError) {
            /**
			 * Backend (Legion) validates whether the string is URI compliant. But URL expects
			 * the string to have a protocol. This is not validated by URI compliancy. So
			 * following is just a quick fix just for display purposes.
			 */ hostname = $1c729a8c68a0370e$export$eb5a321f13bbb969('http://' + url);
        }
    } catch (error) {
        return '';
    }
    return hostname.replace(/^www\./, '');
};
const $1c729a8c68a0370e$export$eb5a321f13bbb969 = (url)=>{
    const urlObj = new URL(url);
    return urlObj.hostname;
};
module.exports["getDomainFromLinkUri"] = $1c729a8c68a0370e$export$cda14c9dfe45538;

});

parcelRegister("jcyBI", function(module, exports) {
function $7a2fbd03d879f5df$export$f8b10795b163b139(cloudId) {
    if (!cloudId) return undefined;
    return {
        metadata: {
            headers: {
                'X-Query-Context': `ari:cloud:platform::site/${cloudId}`
            }
        }
    };
}
function $7a2fbd03d879f5df$export$1bb4ca53dbed1b2b(cloudId) {
    if (!cloudId) return undefined;
    return {
        'X-Query-Context': `ari:cloud:platform::site/${cloudId}`
    };
}
module.exports["createQueryContextCacheConfig"] = $7a2fbd03d879f5df$export$f8b10795b163b139;

});


//# sourceMappingURL=TeamProfileCardEntryPoint.5b3ba827.js.map
